{
  "404.message": "La Página que ha solicitado no existe. Puede intentar buscar, o navegar por la web para encontrar la página que esta buscando.",
  "404.message.reason1": "La página no existe.",
  "404.message.reason2": "La página existe, pero no tienes permiso para verla.",
  "404.nav.dashboard": "Su Cuadro de Mando",
  "404.nav.home": "Página Principal del sitio",
  "404.nav.title": "Ir a...",
  "404.search.title": "Buscar en la Web",
  "aboutpage.section.title": "Atlassian Confluence Cloud y plugins de Confluence Cloud",
  "accessibility.user.icon": "Icono del usuario",
  "action.add.comment": "Añadir Comentario",
  "action.edit.comment": "Editar Comentario",
  "action.reorder.pages.sentence": "Reordenar las páginas",
  "action.space.addons": "Complementos",
  "action.space.overview": "Resumen",
  "actions.word": "Acciones",
  "add.comment": "Añadir Comentario",
  "add.comment.accesskey": "m",
  "add.shortcut": "Añadir atajo",
  "add.word": "Añadir",
  "addlabels.teamlabels": "Categorías",
  "adf.translation.error.in.render.description.prod": "Actualiza la página y vuelve a intentarlo. Si el problema persiste, comunícate con el <a target=\"_blank\" href=\"{link}\">soporte de Atlassian</a>.",
  "adf.translation.error.in.render.description.staging": "El contenido no se puede mostrar debido a un error del ADF. Puedes hablar sobre esto en el canal de Slack <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>.",
  "adf.translation.error.in.render.title.prod": "No hemos podido mostrar tu contenido",
  "adf.translation.error.in.render.title.staging": "Error del ADF al mostrar el contenido",
  "adg3.feedback.placeholder": "Háblanos de tu experiencia usando Confluence para que podamos hacerlo aún mejor.",
  "adg3.give.feedback": "Háganos llegar sus comentarios",
  "adg3.onboarding.docs.link": "Más información",
  "adg3.onboarding.next": "Siguiente",
  "adg3.onboarding.prev": "Anterior",
  "adg3.onboarding.sidebar.done": "Entendido",
  "adg3.onboarding.skip": "Saltar",
  "adg3.onboarding.start": "Inicio",
  "adg3.onboarding.step1.content": "Hemos actualizado los colores, los iconos y los tipos de letras, para que sea más fácil detectar las cosas importantes y que sus ojos no se cansen tanto.",
  "adg3.onboarding.step1.title": "Saluda a la nueva experiencia Confluence",
  "adg3.onboarding.step2.content": "Todos los elementos que más necesita (buscar, crear y navegar) están en la barra lateral.",
  "adg3.onboarding.step2.title": "Navegación sencilla en la barra lateral",
  "adg3.onboarding.step3.content": "¿No recuerda en qué estaba trabajando? El panel de búsqueda le ayuda con una lista de las páginas que visitó recientemente.",
  "adg3.onboarding.step3.title": "Retomar donde lo dejó",
  "adg3.onboarding.step4.content": "Déjanos comentarios desde tu perfil para ayudar a hacer esto aún mejor. ¿No estás listo para la experiencia aún? Puedes desactivarla también desde de tu perfil.",
  "adg3.onboarding.step4.content.no.optout": "Tus comentarios son muy importantes para mejorar la experiencia de Confluence. Cuéntanos lo que piensas a través de tu perfil para ayudarnos a mejorarla aún más.",
  "adg3.onboarding.step4.title": "Ayúdenos a construir la mejor versión posible de Confluence",
  "adg3.onboarding.user.optin.content": "Hemos hecho cambios en base a la retroalimentación, pero seguimos mejorando.Envíanos una nota a través de Enviar retroalimentación en la barra lateral si hay algo más que quieras compartir.",
  "adg3.onboarding.user.optin.done": "Lo he pillado",
  "adg3.onboarding.user.optin.title": "La nueva experiencia de Confluence ya está aquí para todos",
  "adg3.send.feedback": "Enviar comentarios",
  "adg3.sidebar.button.configure": "Configurar barra lateral",
  "adg3.sidebar.button.done": "Listo",
  "adg3.sidebar.button.gotit": "Entendido",
  "adg3.sidebar.link.disable": "Deshabilitar",
  "adg3.sidebar.link.enable": "Habilitar",
  "adg3.user.profile.other": "Mi Confluence",
  "admin.section.security.title": "Usuarios & Seguridad",
  "administration.name": "Administración",
  "all.updates.mainBanner": "No están pasando muchas cosas... Todavía",
  "all.updates.subBanner": "Entérese de todo lo que está sucediendo en este sitio. Las páginas, archivos, ediciones y comentarios nuevos aparecerán aquí.",
  "all.updates.subBanner2": "Es hora de crear el siguiente gran trabajo.",
  "all.updates.title": "Todas las actualizaciones",
  "anonymous.name": "Anónimo",
  "archived.spaces": "Espacios archivados",
  "atlassian.can.contact": "¿Podemos contactar con usted para hacer un seguimiento de sus comentarios?",
  "atlassian.home.name": "Página de inicio de Atlassian",
  "attach.files.no.permission": "Deberá solicitar permiso para insertar archivos aquí.",
  "attach.files.tip.close": "¡Entendido!",
  "attach.files.tip.desc": "Arrastra los archivos en la página para insertarlos directamente.",
  "attach.files.tip.title": "Sugerencia:",
  "attach.files.upload.files": "Subir ficheros",
  "attach.files.upload.images": "Subir imágenes",
  "audit.logging.category.user.management": "Usuarios y grupos",
  "aui.sidebar.collapse.tooltip": "Contraer barra lateral ( [ )",
  "aui.sidebar.expand.tooltip": "Ampliar barra lateral ( [ )",
  "author.name": "Autor",
  "blog.personal.name": "Blog Personal",
  "blog.post": "Noticia",
  "blog.word": "Blog",
  "blogtree.failed.load.content": "Error al cargar las entradas de blog",
  "blueprint.navigation.items.create.new.template": "Crear nueva plantilla",
  "blueprint.navigation.items.create.new.template.disabled": "Solo los administradores de espacios pueden crear plantillas",
  "blueprint.navigation.items.filter.for.templates": "Filtra las plantillas",
  "blueprint.navigation.items.page.templates.header": "Plantillas de página",
  "button.cancel": "Cancelar",
  "cache.name.com.atlassian.confluence.pages.Draft": "Borradores",
  "calendar.share.button.keyboard.shortcut.desc": "Compartir",
  "calendar3.addcalendar": "Añadir Calendario",
  "calendar3.helptip.learn.more": "Obtener más información",
  "calendar3.spacecalendars.header": "Calendarios",
  "calendar3.spacecalendars.onboarding.button.add.label": "Añadir calendario",
  "calendar3.spacecalendars.onboarding.intro": "Añade un calendario para realizar el seguimiento de las vacaciones de tu equipo, planificar proyectos de Jira y coordinar a todos en fechas importantes.",
  "calendar3.spacecalendars.onboarding.title": "La fuente certera para tu equipo o tu proyecto",
  "cancel.name": "Cancelar",
  "captcha.response.failed": "El texto introducido no es el mismo que el que aparece en la imagen.",
  "categories.name": "Categorías",
  "changeboarding.dnd.pagetree.spacesettings.banner": "La organización del espacio se ha vuelto más fácil con la posibilidad de arrastrar y soltar para reordenar las páginas en la barra lateral.",
  "changeboarding.dnd.pagetree.spotlight.message": "Arrastra y suelta para mover páginas y organizar el espacio.",
  "changes-diff.heading.key": "Clave",
  "changes-diff.these.lines.were.added": "Se ha añadido esta línea.",
  "changes-diff.these.lines.were.removed": "Se ha eliminado esta línea.",
  "changes-diff.this.content.was.modified": "El formato se ha cambiado.",
  "clear.name": "Borrar",
  "clipboardaccess.browser.not.supported": "Su navegador no soporta pegar imágenes del portapapeles.",
  "clipboardaccess.ok": "Aceptar",
  "close.draft.name": "Cerrar borrador",
  "close.name": "Cerrar",
  "collab.edit.user.limit.msg.body": "<p>Esta página es tan popular que ha alcanzado la cantidad máxima de editores simultáneos.</p><p>Vuelva a intentarlo cuando no esté tan concurrida.</p>",
  "collab.edit.user.limit.msg.title": "En este momento no puede editar esta página",
  "collab.status.connected": "Listo para empezar",
  "collab.status.connecting": "Conectando…",
  "collab.status.error": "No se pueden guardar los cambios",
  "collab.status.tooltip.error": "Copia tu trabajo, actualiza la página e intentaremos volver a conectarte.",
  "collab.status.tooltip.failure": "No podemos conectar con el servidor. Comprueba tu conexión a Internet y continuaremos intentando conectarte",
  "collab.status.tooltip.success": "Guardamos automáticamente los cambios.",
  "collapse.name": "Contraer",
  "colourname.property.style.bordercolour": "Bordes y Divisores",
  "colourname.property.style.breadcrumbstextcolour": "Texto de la barra superior",
  "colourname.property.style.headerbuttonbasebgcolour": "Fondo de botones de encabezado",
  "colourname.property.style.headerbuttontextcolour": "Texto de botones de encabezado",
  "colourname.property.style.headingtextcolour": "Texto del Encabezado",
  "colourname.property.style.linkcolour": "Enlaces",
  "colourname.property.style.menuitemselectedbgcolour": "Fondo de selección de elementos del menú",
  "colourname.property.style.menuitemselectedtextcolour": "Texto de selección de elementos del menú",
  "colourname.property.style.menuitemtextcolour": "Texto de los elementos del menú de la página",
  "colourname.property.style.menuselectedbgcolour": "Fondo de selección del menú de página",
  "colourname.property.style.navbgcolour": "Fondo de Barra de Menú",
  "colourname.property.style.navselectedbgcolour": "Fondo seleccionado de Barra de Menú",
  "colourname.property.style.navselectedtextcolour": "Texto seleccionado de Barra de Menú",
  "colourname.property.style.navtextcolour": "Texto de Barra de Menú",
  "colourname.property.style.searchfieldbgcolour": "Fondo del campo de búsqueda",
  "colourname.property.style.searchfieldtextcolour": "Texto del campo de búsqueda",
  "colourname.property.style.spacenamecolour": "Texto del nombre del espacio",
  "colourname.property.style.topbarcolour": "Barra Superior",
  "colourname.property.style.topbarmenuitemtextcolour": "Texto de elementos del menú de la barra superior",
  "colourname.property.style.topbarmenuselectedbgcolour": "Fondo de selección del menú de la barra superior",
  "colourname.property.style.topbarmenuselectedtextcolour": "Texto seleccionado del menú de la barra superior",
  "com.atlassian.confluence.contributors.contributors.label": "Colaboradores",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Ver archivo",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Entendido, gracias",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Editar Página",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Planificador de hoja de ruta",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Árbol de páginas",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filtro",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Sugerencia: escriba \"g\" y luego \"r\" en cualquier sitio para abrir este menú rápidamente",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Páginas vistas recientemente",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Estado",
  "com.atlassian.mywork.header.notifications": "Notificaciones",
  "comment.display.name.anonymous": "Anónimo",
  "comment.edit": "Editar",
  "comment.edited": "Editado",
  "comment.name.tooltip": "Añadir un comentario",
  "comment.notification.enable": "Monitorear esta página",
  "comment.permalink": "Enlace permanente",
  "comment.plural": "{0} Comentarios",
  "comment.remove": "Eliminar",
  "comment.reply": "Responder",
  "comment.singular": "1 Comentario",
  "compare.selected": "Comparar versiones seleccionadas",
  "configuration.name": "Configuración",
  "confluence.extra.attachments.attachments.label": "Archivos adjuntos",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Informe de propiedades de página",
  "confluence.home": "Página de inicio de Confluence",
  "confluence.macros.advanced.children.label": "Presentación de secundarios",
  "confluence.macros.advanced.contentbylabel.label": "Contenido por etiqueta",
  "confluence.macros.advanced.recently-updated.label": "Recientemente actualizado",
  "confluence.mobile.nav.switch.to.mobile.action": "Cambiar a la versión para móvil de Confluence",
  "confluence.mobile.nav.switch.to.mobile.text": "Está viendo la versión de escritorio desde un dispositivo móvil.",
  "confluence.mobile.refresh": "Actualizar",
  "confluence.request.access.pagerestricted.inherited.description": "Esto se debe a las restricciones heredadas de una página principal. Un administrador de espacio o la persona que compartió esta página podrían darte acceso.",
  "confluence.request.access.pagerestricted.request.access.button": "Solicitar acceso",
  "confluence.request.access.pagerestricted.requestaccess.description": "Pulsa el botón de acceso a la solicitud y encontraremos a alguien que pueda darte acceso.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "No tienes permiso para editar esta página",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "No tienes permiso para ver esta página",
  "confluence.user.profile.department": "Departamento",
  "confluence.user.profile.location": "Ubicación",
  "confluence.user.profile.position": "Posición",
  "connect.addon.wait.or": "Esperar o",
  "content.empty": "El texto del comentario esta vacío. No se pueden crear comentarios vacíos.",
  "content.kind.decisions": "Decision",
  "content.kind.file-list": "File list",
  "content.kind.jirareport": "Jira report",
  "content.kind.kb-how-to-article": "How to article",
  "content.kind.kb-troubleshooting-article": "Troubleshooting article",
  "content.kind.meeting-notes": "Meeting notes",
  "content.kind.product-requirements": "Product requirements",
  "content.kind.retrospective": "Retrospective",
  "content.kind.shared-links": "Shared links",
  "content.kind.task-report": "Task report",
  "content.type.attachment": "Adjuntos",
  "content.type.blogpost": "Blogs",
  "content.type.page": "Páginas",
  "cq.header.title": "Preguntas",
  "create.blog.post.event.description": "Crear Blog Post",
  "create.drawer.header": "Crear",
  "create.drawer.page.selector.all.pages.in.space": "Todas las páginas de este espacio",
  "create.drawer.page.selector.location.header": "Ubicación",
  "create.drawer.page.selector.no.page.found": "No se han encontrado páginas",
  "create.drawer.page.selector.no.parent.page": "Sin página principal",
  "create.drawer.page.selector.pages.loading": "Cargando páginas",
  "create.drawer.page.selector.parent.page": "Página principal",
  "create.drawer.page.selector.parent.page.tooltip.help": "Los blogs, los calendarios y las preguntas no aparecerán en una página principal",
  "create.drawer.page.selector.recent.pages": "Páginas recientes",
  "create.drawer.page.selector.select.parent.page": "Selecciona una página principal",
  "create.drawer.space.selector.header": "Espacio",
  "create.drawer.space.selector.location.header": "Ubicación",
  "create.drawer.space.selector.no.space.found": "No se han encontrado espacios",
  "create.drawer.space.selector.recent.spaces": "Espacios recientes",
  "create.drawer.space.selector.search.spaces": "Todos los espacios",
  "create.drawer.space.selector.select.a.space": "Selecciona un espacio",
  "create.drawer.space.selector.spaces.loading": "Cargando espacios",
  "create.drawer.space.selector.starred.spaces": "Espacios marcados como favoritos",
  "create.drawer.template.failed.to.load.atlassian.support": "soporte de Atlassian.",
  "create.drawer.template.failed.to.load.content": "Actualiza la página y vuelve a intentarlo. Si el problema persiste, comunícate con el",
  "create.drawer.template.failed.to.load.title": "La plantilla no se cargó",
  "create.name": "Crear",
  "css.file": "Archivo CSS",
  "current.space": "Espacio actual",
  "default.space.homepage.title": "Página de inicio de {0}",
  "delete.name": "Borrar",
  "desc.colourscheme": "Los siguientes colores se pueden personalizar para el siguiente esquema de colores.",
  "description.name": "Descripción",
  "discard.name": "Descartar",
  "discover.applications": "Descubrir aplicaciones",
  "draft": "Borrador",
  "draft.no.content": "Este borrador no tiene contenido.",
  "edit.comment": "Editar Comentario",
  "edit.labels": "Añadir etiquetas",
  "editor-help.fabric.help.center.feedback.item": "Feedback",
  "editor.adf.parsing.error.details": "Detalles del error:",
  "editor.adf.parsing.error.message.prod": "Actualiza la página y vuelve a intentarlo. Si el problema persiste, comunícate con el <a target=\"_blank\" href=\"{link}\">soporte de Atlassian</a>.",
  "editor.adf.parsing.error.message.staging": "Se ha notificado a nuestro equipo, pero también puedes hablar sobre esto en el canal de Slack <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>.",
  "editor.adf.parsing.error.title.prod": "No hemos podido cargar el editor.",
  "editor.adf.parsing.error.title.staging": "Hemos tenido un problema al convertir este documento a ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Adjuntos",
  "editor.attachments.singular": "{0} Adjunto",
  "editor.attachments.zero": "Adjuntos",
  "editor.autocomplete.file.header.text": "Sugerencias de archivo",
  "editor.autocomplete.links.create.link": "Insertar enlace para crear página",
  "editor.autocomplete.links.dialog.search": "Buscar ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Buscar",
  "editor.autocomplete.links.header.text": "Enlaces sugeridos",
  "editor.autocomplete.links.web.link": "Insertar enlace web",
  "editor.autocomplete.macros.dialog.browse": "Abrir explorador de macros",
  "editor.autocomplete.macros.error.load.header": "Error al obtener datos de macro",
  "editor.autocomplete.macros.error.load.retrylink": "Vuelva a intentarlo",
  "editor.autocomplete.macros.header.text": "Macros sugeridas",
  "editor.autocomplete.media.files.dialog.browse": "Abrir la libreria de ficheros",
  "editor.autocomplete.media.header.text": "Sugerencias de archivos multimedia",
  "editor.autocomplete.media.images.dialog.browse": "Abrir explorador de imágenes",
  "editor.autocomplete.media.macros.dialog.browse": "Insertar otros archivos multimedia",
  "editor.autoformat.sampletext.firstcell": "primera celda",
  "editor.autoformat.sampletext.heading": "cabecera",
  "editor.buttons.disable.by.empty.title.tooltip": "Tu página necesita un título antes de que pueda publicarse.",
  "editor.buttons.disable.by.not.saving.tooltip": "Seguimos trabajando...",
  "editor.buttons.disable.by.saving.tooltip": "Todavía estamos guardando tu página.",
  "editor.cancel.discard.changes.confirmation": "Descartar cambios",
  "editor.cancel.discard.changes.message": "Todo el contenido ingresado será descartado. Por favor confirmar.",
  "editor.cancel.discard.changes.title": "Confirme que desea descartar todos los cambios",
  "editor.cant.publish.changes": "No se pueden publicar cambios",
  "editor.change.comment": "¿Qué has cambiado?",
  "editor.close.publish.tooltip": "Guardar cambios sin publicarlos",
  "editor.close.update.tooltip": "Guardar cambios sin actualizarlos",
  "editor.collab.user.limit.body": "Esta página es muy popular. Se ha alcanzado la cantidad máxima de editores simultáneos. Vuelve a intentarlo cuando no haya tanto movimiento.",
  "editor.collab.user.limit.title": "No puedes editar esta página en este momento.",
  "editor.collaborative-editing.load.error": "Cargar el editor está tardando más de lo habitual. Dele unos minutos, luego actualice su página si todavía no se ha cargado. Hable con su administrador de Confluence si el problema persiste.",
  "editor.collaborative-editing.refresh-editor.error": "Se produjo un error al cargar el editor. Vuelva a intentarlo.",
  "editor.collaborative.mode.disabled": "En estos momentos, la edición colaborativa está fuera de línea. Copie su trabajo, luego actualice la página para seguir editando.",
  "editor.collaborative.mode.enabled": "La edición colaborativa se desactivó, pero ya vuelve a estar en funcionamiento. Copie sus cambios y actualice la página para seguir editando.",
  "editor.content.appearance.toggle.fixed.width": "Ancho completo de la página",
  "editor.content.appearance.toggle.full.width": "Ancho fijo de la página",
  "editor.content.placeholder.11": "¿Sabías que puedes incorporar todo tipo de elementos geniales a esta página, como una tabla de contenido, una fecha o una hoja de ruta? Escribe / para abrir una lista.",
  "editor.content.placeholder.ai": "Escribe /ai para Atlassian Intelligence, / para añadir elementos o @ para mencionar a alguien (se lo haremos saber).",
  "editor.content.placeholder.bpqa": "Escribe / para ver una lista de elementos, @ para mencionar a alguien o selecciona una de las siguientes opciones:",
  "editor.content.placeholder.bpqa.ai": "Escribe /ai para Atlassian Intelligence, / para los elementos o @ para mencionar a alguien, o bien selecciona una de las siguientes opciones:",
  "editor.content.placeholder.easy.mentions": "Escribe / para todos los elementos o @ para mencionar a alguien.",
  "editor.content.placeholder.slash": "Escribe / para insertar cualquier elemento",
  "editor.content.placeholder.slash.bracket": "Se puede insertar rápidamente cualquier elemento introduciendo /",
  "editor.content.reconciliation.error.details": "Detalles del error:",
  "editor.content.reconciliation.error.fatal.prod": "Nuestro equipo ha sido notificado. Espera unos minutos y vuelve a intentarlo. Si el problema persiste, comunícate con el soporte de Atlassian.",
  "editor.content.reconciliation.error.fatal.staging": "Nuestro equipo ha sido notificado, pero también puedes hablar sobre esto en el canal de Slack #cc-content-experience.",
  "editor.content.reconciliation.error.retrying": "Volveremos a intentarlo dentro de {0}...",
  "editor.content.reconciliation.error.title": "Esta página no se cargó",
  "editor.content.reconciliation.networkerror.fatal.prod": "La incidencia debería solucionarse al actualizar la página. Si el problema persiste, comunícate con el <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">soporte de Atlassian</a> o tu administrador de espacio.",
  "editor.content.reconciliation.networkerror.title": "Tenemos problemas para cargar tu contenido",
  "editor.discard-on-close.tooltip": "Descartar borrador vacío",
  "editor.discard-to-published.button.label": "Descartar",
  "editor.discard-to-published.button.tooltip": "Retroceder a la última versión publicada de la página.",
  "editor.discard-to-published.dialog.title": "¿Descartar cambios no publicados?",
  "editor.discard-to-published.dialog.warning": "Esto restaurará el editor a la última versión publicada de esta página. Si alguien más tiene cambios no publicados en la página, estarás descartando también esos cambios.",
  "editor.discard-to-published.error.message": "No podemos obtener la última versión publicada de la página en este momento. Espera unos minutos y trata de descartar el borrador de nuevo.",
  "editor.discard-to-published.error.title": "No es posible volver a la última versión publicada",
  "editor.discard-to-published.success.message": "Revertido con éxito a la última versión publicada",
  "editor.draft.can.be.migrated": "¡La edición colaborativa está activada! De modo que para poder seguir trabajando en la página, tenemos que migrar su contenido a un nuevo borrador. <br> <a href={0}>Migrar ahora</a>",
  "editor.dynamic-macro.preview.limit.desc": "La vista previa de la macro dinámica en el borrador solo se admite completamente cuando se activa la opción de borradores compartidos.",
  "editor.ellipsis.blog.delete": "Eliminar entrada de blog no publicada",
  "editor.ellipsis.import-document": "Abrir plantilla e importar documentos",
  "editor.ellipsis.open.template.browser": "Abrir explorador de plantillas",
  "editor.ellipsis.open.templates.and.import": "Plantillas e importar documentos",
  "editor.ellipsis.page.delete": "Eliminar página no publicada",
  "editor.ellipsis.remove": "Volver a la última versión publicada",
  "editor.ellipsis.resolved.comments": "Comentarios resueltos",
  "editor.ellipsis.view-changes": "Ver cambios",
  "editor.error.delayed.publishing": "Seguiremos tratando de publicarla. Si tarda demasiado, actualiza la página y haz clic en <strong>Publicar</strong>.",
  "editor.error.delayed.publishing.title": "Tenemos problemas para publicar tu contenido.",
  "editor.excerpt.include.macro.error": "Error al cargar el extracto desde \"{0}\".",
  "editor.excerpt.panel.title.loading": "Cargando...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Entrada de blog sin título",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Página sin título",
  "editor.fabric.share.invite.to.edit.form.title": "Invitar para editar",
  "editor.files.may.be.uploading": "Es posible que algunos archivos todavía se estén cargando. Aguarda un minuto y vuelve a intentarlo. Si no funciona, actualiza la página y vuelve a cargar los archivos que parecen rotos antes de publicar.",
  "editor.generic.refresh": "Algo funcionó mal en el editor. Copie los cambios que no ha guardado y actualice la página para seguir editando.",
  "editor.go.back": "Regresar",
  "editor.heartbeat.unauthorised.warning.generic.body": "Este contenido se ha movido, restringido o eliminado. Le recomendamos que copie todo lo que necesite y cierre el editor.",
  "editor.heartbeat.unauthorised.warning.generic.title": "No hay acceso a esta página",
  "editor.heartbeat.unauthorised.warning.page-move.body": "No puedes publicar debido a que se ha movido una página o se han modificado las restricciones. Te recomendamos que copies todo lo que necesites y cierres el editor.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Los permisos de la página han cambiado",
  "editor.help.how.to.use.blueprint": "Cómo utilizar {blueprintType}",
  "editor.help.templates": "Usar plantillas de páginas",
  "editor.help.updates": "Actualizaciones de la edición",
  "editor.help.updates.1.description": "La primera fase de las mejoras que introduciremos a la edición ha llegado a las entradas de blog. Contenido con capacidad de respuesta, mejor manejo de las imágenes y una interfaz optimizada. Crea una nueva entrada de blog para ver los cambios.",
  "editor.help.updates.1.title": "Entradas de blog",
  "editor.help.updates.2.description": "La nueva experiencia de edición ha llegado a las notas de reunión. Las últimas novedades incluyen  funcionalidad avanzada en las tablas, que se activa haciendo clic en ellas, así como mejoras en materia de velocidad y confiabilidad.",
  "editor.help.updates.2.title": "Notas de reunión",
  "editor.hints.close": "Cerrar sugerencias",
  "editor.hints.next": "Próxima sugerencia",
  "editor.labels": "{0}",
  "editor.labels.desc": "Editar etiquetas de página",
  "editor.labels.plural": "{0} Etiquetas",
  "editor.labels.singular": "{0} Etiqueta",
  "editor.labels.zero": "Etiquetas",
  "editor.learn.more": "Más información",
  "editor.location.desc": "Añadir ubicación",
  "editor.minor.edit": "Notificar a los observadores",
  "editor.offline.before.save.error": "No se puede establecer comunicación con el servidor. En este momento, no es posible guardar.",
  "editor.offline.preview.error": "No se puede alcanzar el servidor. Comprueba que estás conectado a Internet y que Confluence está en funcionamiento.",
  "editor.offline.save.error": "No se puede establecer comunicación con el servidor. No es posible guardar en este momento.",
  "editor.offline.save.error.generic": "Ocurrió un error al procesar la solicitud.",
  "editor.offline.save.noauthorized": "Tu sesión ha expirado. Tendrás que iniciar sesión de nuevo o cambiar de cuenta para seguir trabajando. \n <div><a href=\"/login?application=confluence\">Inicia sesión o cambia de cuenta</a></div>",
  "editor.offline.save.noauthorized.title": "No es posible conectarse con el servidor",
  "editor.offline.save.page.exist.content": "Ya existe una página con el título '{'0'}' en este espacio. Indica un título diferente para la página.",
  "editor.onboarding.draft.placeholder": "Escribe / para obtener una lista de elementos útiles que puedes añadir a la página, como una tabla de contenidos o una hoja de ruta.<br/>Si tu mente se ha quedado tan en blanco como esta página, puedes empezar con una de las plantillas de la derecha →",
  "editor.onboarding.spotlight.body": "Averigua qué se modificará y por qué.",
  "editor.onboarding.spotlight.finish": "Entendido",
  "editor.onboarding.spotlight.title": "Actualizaremos tus plantillas, una a una",
  "editor.onboarding.step1.content": "Estamos trabajando para proporcionarte las funciones que has estado solicitando, comenzando con una legibilidad mejorada, herramientas de formato más inteligentes y un aspecto más moderno. <br /><a href=''{linkCAC}' target='_blank'>Obtén más información sobre lo que está cambiando</a>",
  "editor.onboarding.step1.title": "Publicaciones de blog más amigables",
  "editor.onboarding.step2.content": "Las funciones que más utilizas se encuentran en la barra de herramientas, mientras que las herramientas más avanzadas se despliegan con en el signo de más. ¡También tienes un montón de nuevos emojis para alegrarte el día! <br/><a href=''{linkCAC}' target='_blank'>Obtén más información sobre lo que está cambiando</a>",
  "editor.onboarding.step2.title": "¿Buscas algo?",
  "editor.onboarding.step3.content": "Este es un trabajo en progreso y necesitamos tu ayuda para hacerlo increíble. Envíanos tus comentarios y sigue la <a href=''{linkCAC}' target='_blank'>página de Confluence</a> para mantenerte actualizado sobre los cambios. <br/><a href=''{linkCAC}' target='_blank'>Obtén más información acerca de lo que está cambiando.</a>",
  "editor.onboarding.step3.title": "Creemos algo genial juntos",
  "editor.page.can.not.be.accessed.message": "Es posible que tu sesión haya expirado. Tendrás que iniciar sesión de nuevo o cambiar de cuenta para seguir trabajando. \n <div><a href=\"/login?application=confluence\">Inicia sesión o cambia de cuenta</a></div>",
  "editor.page.can.not.be.accessed.title": "No es posible acceder a este contenido.",
  "editor.page.conflict.message": "Actualice la página para intentar re-establecer la conexión.",
  "editor.page.conflict.title": "Imposible sincronizar con el servidor.",
  "editor.page.is.too.big": "Esta página es demasiado grande para guardarla. Puede dividirla en varias páginas y luego usar la <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">macro de inclusión de páginas</a> para mostrar el contenido.",
  "editor.page.is.trashed.message": "Copia tu contenido, luego añádelo a una nueva página o <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">restaura esta página de la papelera</a> e intenta de nuevo.</div>",
  "editor.page.is.trashed.title": "Este contenido se ha eliminado",
  "editor.page.legacy.draft.deprecated": "¡Ha llegado la edición colaborativa! Eso significa que necesitamos un poco de ayuda por tu parte para reiniciar tu sesión de edición. Todo lo que tienes que hacer es copiar el contenido, editar esta página de nuevo y después pegarla y guardarla.",
  "editor.page.moved.message.body": "No te preocupes. Podrás publicar tus cambios cuando estés listo. <br /><br /> Nueva ubicación: {0}",
  "editor.page.moved.message.title": "{0} movió esta página",
  "editor.page.moved.message.unknown.mover": "Otro usuario",
  "editor.placeholder.broken.image": "Imagen rota",
  "editor.placeholder.broken.link": "Enlace roto",
  "editor.placeholder.broken.macro": "Macro rota",
  "editor.placeholder.error": "Error",
  "editor.preview.error": "Hubo un error al cargar la vista previa. Vuelva a intentarlo más tarde.",
  "editor.publish.blog": "Publicar",
  "editor.publish.blog.desc": "Publique su entrada de blog",
  "editor.publish.external.share.label": "Compartido externamente",
  "editor.publish.hotkey.description": "Para publicar este contenido, selecciona {keyCombination} en el teclado.",
  "editor.publish.with.comment": "Publicar con comentario sobre la versión...",
  "editor.publish.without.notify": "Publicar sin notificar a los interesados",
  "editor.quit-dialog.button.delete.blog.exit": "Eliminar entrada de blog",
  "editor.quit-dialog.button.delete.page.exit": "Eliminar página",
  "editor.quit-dialog.button.discard.changes.by.many": "Descartar los cambios de <strong>todo el mundo</strong>",
  "editor.quit-dialog.button.discard.changes.by.one": "Descartar <strong>todos los</strong> cambios",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Descartar todos los cambios no publicados",
  "editor.quit-dialog.button.discard.limited.tooltip": "La edición colaborativa está deshabilitada. Puede descartar los cambios cuando esté activada de nuevo.",
  "editor.quit-dialog.button.revert.blog.exit": "Recuperar la entrada de blog",
  "editor.quit-dialog.button.revert.page.exit": "Recuperar página",
  "editor.quit-dialog.button.save.exit": "Conservar borrador",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Hay cambios realizado por usted y otras personas que no han sido publicados todavía.</p> <p>Si descarta los cambios, eliminará los cambios realizados por las siguientes personas y volverá a la última versión publicada de esta página. No podrán recuperar su trabajo si hace esto.</p> <p>Estas personas han hecho cambios:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>Ha realizado cambios que no han sido publicados todavía.</p> <p> Si descarta los cambios, se eliminarán sus cambios no publicados. No puede deshacer esta acción.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Se eliminará esta publicación de blog en la que tú y otras personas han trabajado.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "Una vez que eliminas una entrada de blog no publicada, se elimina para siempre.",
  "editor.quit-dialog.delete.page.changes.by.many": "Esto eliminará permanentemente esta página, en la que usted y estas otras personas han trabajado.",
  "editor.quit-dialog.delete.page.changes.by.one": "Si eliminas una página no publicada, se elimina para siempre.",
  "editor.quit-dialog.last.edited": "Última edición",
  "editor.quit-dialog.link.hide.diff": "Ocultar cambios",
  "editor.quit-dialog.link.show.diff": "Mostrar cambios",
  "editor.quit-dialog.publish.changes": "<p>Hay cambios realizados por usted y otras personas que no han sido publicados todavía.</p> <p> Estas personas han hecho cambios:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Esto eliminará de forma permanente todos los cambios que hayas realizado desde la última vez que se publicó esta entrada de blog.",
  "editor.quit-dialog.revert.changes.by.many": "Esto eliminará permanentemente todos los cambios que las siguientes personas hayan realizado, desde la última vez que se publicó esta página.",
  "editor.quit-dialog.revert.page.changes.by.one": "Esto eliminará permanentemente todos los cambios que hayas realizado desde la última publicación de esta página.",
  "editor.quit-dialog.title.blogpost.delete": "¿Eliminar entrada de blog no publicada?",
  "editor.quit-dialog.title.discard": "¿Volver a la última versión publicada?",
  "editor.quit-dialog.title.exit": "Cerrar el editor",
  "editor.quit-dialog.title.page.delete": "¿Eliminar la página no publicada?",
  "editor.quit-dialog.title.publish": "¿Publicar todos los cambios?",
  "editor.restrictions.desc": "Editar restricciones de página",
  "editor.return.to.edit": "Regresar al modo de edición",
  "editor.satisfaction.survey.description": "¿Qué tal fue tu experiencia al editar?",
  "editor.satisfaction.survey.final.description": "Se han enviado tus comentarios",
  "editor.satisfaction.survey.final.title": "Gracias",
  "editor.satisfaction.survey.question.bad": "Lamentamos oír eso. ¿Qué salió mal? (opcional)",
  "editor.satisfaction.survey.question.good": "¡Gracias! ¿Qué aspectos te gustaron? ¿Qué aspectos se podrían mejorar? (opcional)",
  "editor.satisfaction.survey.title": "Tu página se ha publicado",
  "editor.save.draft.desc": "Guarda tu borrador",
  "editor.save.page.desc": "Guarda su página",
  "editor.shared.draft.done.desc": "Guarda el borrador; si está vacío, descártalo",
  "editor.shared.draft.publish.desc": "Publicar cambios",
  "editor.shared.draft.update.desc": "Actualizar página publicada",
  "editor.shortcuts": "Editar atajos de teclado",
  "editor.synchrony.publish-page.message": "{0} ha publicado esta página.",
  "editor.template.changing.variable.dialog.title": "Editar variable de plantilla",
  "editor.template.variable.input.creation.error.action": "Visita el soporte de Atlassian",
  "editor.template.variable.input.creation.error.description": "Actualiza la página y vuelve a intentarlo. Si sigue ocurriendo, dínoslo mediante el siguiente enlace.",
  "editor.template.variable.input.creation.error.title": "Algo ha ido mal",
  "editor.template.variable.list.field.placeholder": "opción1, opción2, opción 3",
  "editor.template.variable.name.field": "Nombre de variable",
  "editor.title.is.empty": "Añada un título de página antes de publicar.",
  "editor.title.is.empty.title": "Esta página necesita un nombre",
  "editor.title.placeholder": "Título de la página",
  "editor.title.too.long": "Esto no puede tener más de 255 caracteres.",
  "editor.unavailable.generic.body": "La edición no está disponible en este momento. Vuélvalo a intentar en unos minutos.",
  "editor.unavailable.title": "No se puede editar",
  "editor.unpublished.changes.lozenge.label": "Sin publicar",
  "editor.unpublished.changes.lozenge.tooltip": "Esta página contiene cambios sin publicar",
  "editor.waiting.to.publish.changes": "Es posible que aún haya una carga de archivo en progreso.",
  "editor.waiting.to.publish.changes.title": "Ten paciencia, estamos tardando un poco.",
  "email.text.added.by": "Agregado por",
  "error.connection.lost.body": "Vamos a esperar mientras reconectas.",
  "error.connection.lost.title": "Parece que has perdido la conexión.",
  "error.connection.recovered.action": "Recarga el contenido",
  "error.connection.recovered.title": "Nueva actividad disponible",
  "error.notfound.title": "Ohh, no hemos podido encontrar esa página.",
  "error.recovery.body": "Tus cambios están a salvo. Actualiza la página y vuelve a intentarlo.",
  "error.recovery.title": "Ha habido un problema al cargar el editor",
  "error.server-error.body": "Prueba de nuevo más tarde.",
  "error.server-error.title": "Algo ha ido mal.",
  "error.session.expired.body": "Esto no debería pasar a menudo.",
  "error.session.expired.title": "Parece que hemos perdido tu sesión.",
  "excel.file": "Hoja de cálculo de Microsoft Excel",
  "excel.macro.file": "Hoja de cálculo de Microsoft Excel habilitada para macros",
  "excel.template.file": "Plantilla de Microsoft Excel",
  "excel97.file": "Hoja de cálculo de Microsoft Excel",
  "excel97.template.file": "Plantilla para Microsoft Excel 97",
  "existing.blogpost.placeholder": "Título de la entrada de blog",
  "expand-macro.default-title": "Haz clic aquí para ampliar...",
  "expand.name": "Ampliar",
  "fabric.editor.announcement.datednotice.main": "El {0}, actualizaremos tu cuenta para que puedas disfrutar de nuestra nueva experiencia de edición.",
  "fabric.editor.announcement.dismiss": "Descartar",
  "fabric.editor.announcement.greeting": "Hola, {0}.",
  "fabric.editor.announcement.initialnotice.main": "Tu forma de crear contenido en Confluence va a cambiar dentro de unas semanas.",
  "fabric.editor.announcement.link.action": "Averigua qué va a cambiar y qué funcionalidades nuevas adquirirás.",
  "fabric.editor.announcement.rollbacknotice.action": "Lee el anuncio sobre cómo devolver las páginas existentes a la experiencia anterior.",
  "fabric.editor.announcement.rollbacknotice.main": "Recientemente, tus páginas se actualizaron por accidente a la nueva experiencia de edición. Hemos revertido este error.",
  "fabric.editor.announcement.tryit.action": "Haz la prueba en una página nueva.",
  "fabric.editor.announcement.tryitnotice.main": "La nueva experiencia de edición te ofrece páginas más bonitas y funciones nuevas como las macros en directo.",
  "fabric.editor.changeboarding.banner.action": "Mira lo nuevo que puedes hacer.",
  "fabric.editor.changeboarding.banner.dismiss": "Descartar",
  "fabric.editor.changeboarding.banner.main": "Hola, {0}. Estamos haciendo algunos cambios para ayudarte a crear un contenido más legible y con mejor presentación.",
  "fabric.editor.page.removed.description": "Actualiza ahora.",
  "fabric.editor.page.removed.title": "Esta página se ha archivado o eliminado recientemente",
  "fabric.editor.permission.removed.description": "Se han cambiado los permisos de esta página. Ponte en contacto con un administrador para obtener ayuda.",
  "fabric.editor.permission.removed.title": "No podemos mostrar esta página",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Amplía <strong>todos los elementos de la página</strong> horizontalmente, lo que deja menos espacio en blanco. El conmutador también restablece la anchura fija del contenido de la página.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Controla la anchura de <strong>cada columna, tabla </strong> y la mayoría de las <strong>macros</strong> mediante las funciones de anchura o anchura completa; también puedes seleccionar determinados elementos para que se mantengan en una anchura fija.</p>",
  "fabric.full.width.help.center.tableElement.title": "Conmutar elemento individual",
  "fabric.help.center.columns.details": "<p>Añade una <strong>columna</strong> a tu página y usa el <strong>menú flotante</strong> para elegir entre 2 o 3 configuraciones de columnas.",
  "fabric.help.center.columns.title": "Columnas",
  "fabric.help.center.dialog.title": "Información básica",
  "fabric.help.center.imageDisplay.details": "<p>Selecciona una imagen, arrastra los <strong>tiradores</strong> para ajustar el tamaño o utiliza el <strong>menú flotante</strong> para cambiar la alineación.</p>",
  "fabric.help.center.imageDisplay.title": "Diseño de imagen",
  "fabric.help.center.layouts.details": "<p>Usa <kbd>←</kbd> o <kbd>→</kbd> para cambiar el diseño de las columnas, tablas y macros.</p><p>Elige entre un <strong>ancho fijo</strong> que permanezca igual en todas las pantallas, un <strong>ancho completo</strong> capaz de expandirse para cubrir el espacio o un <strong>ancho intermedio</strong>.</p>",
  "fabric.help.center.layouts.title": "Diseños",
  "fabric.help.center.menuitem.title": "Tutorial",
  "fabric.help.center.slashCommands.details": "<p>Pulsa la tecla <kbd>/</kbd> para abrir un menú e introducir contenidos como <strong>tablas</strong>, <strong>macros</strong> y <strong>fechas</strong> en tu página sobre la marcha.</p>",
  "fabric.help.center.slashCommands.title": "Comandos de barra diagonal",
  "fabric.help.center.spotlight.body": "Vuelve a revisar el tutorial en cualquier momento.",
  "fabric.help.center.spotlight.header": "¿Necesitas ponerte al día?",
  "fabric.help.center.tableManipulation.details": "<p>Edita o cambia el formato de las tablas usando los <strong>bordes de las tablas</strong>, el <strong>menú desplegable</strong> y el <strong>menú flotante</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Manipulación de tablas",
  "fabric.help.center.templates.details": "<p>Encuentra una plantilla que se ajuste a tus necesidades. Vuelve a abrir el panel desde el menú Más acciones (•••) cuando esté cerrado.</p>",
  "fabric.help.center.templates.title": "Plantillas",
  "fabric.help.center.title": "Información básica",
  "fabric.insert.external.image": "Insertar imagen desde la web",
  "fabric.template.can.not.parse.content": "No podemos abrir esta plantilla porque contiene elementos dañados o no admitidos.",
  "fabric.template.can.not.save.error.title": "No se pueden guardar los cambios",
  "fabric.template.can.not.save.error.title.duplicate": " Ya hay una plantilla llamada <strong>{0}</strong>. Dale a tu plantilla un título diferente para guardarla.",
  "fabric.template.found.invalid.node": "Varias variables de la plantilla que tienen el mismo nombre  \"{variableNames}\" pero diferentes parámetros.",
  "favourite.spaces": "Mis espacios",
  "feedback.flag.thanks.description": "Tus comentarios nos ayudan a ofrecer experiencias mejores.",
  "feedback.flag.thanks.title": "¡Gracias!",
  "filter.name": "Filtro",
  "gif.file": "Archivo GIF",
  "global.spaces": "Espacios del sitio",
  "globaladminbilling.label": "Facturación",
  "header.or.footer.unsupported.macros.list": "Las siguientes macros no son compatibles actualmente con el {0}:",
  "header.or.footer.unsupported.macros.title": "Macros no compatibles",
  "heading.comment": "Cambiado por",
  "heading.createpage": "Crear Página",
  "heading.createpage.sentence": "Crear Página",
  "heading.operations": "Operaciones",
  "heading.version.date": "Publicado",
  "heading.version.number": "Versión",
  "help.name": "Ayuda",
  "help.us.improve": "Ayúdanos a mejorar",
  "hipchat.presence.status.available": "Disponible",
  "hipchat.presence.status.away": "Ausente",
  "hipchat.presence.status.dnd": "No molestar",
  "hipchat.presence.status.offline": "Sin conexión",
  "html.file": "Archivo HTML",
  "icon.tooltip.remove": "Eliminar",
  "icon.tooltip.undo": "Deshacer",
  "image.browser.imageurl.label": "URL de la imagen",
  "image.height": "Altura",
  "image.properties.dialog.cancel": "Cancelar",
  "image.properties.dialog.heading": "Propiedades de Imagen",
  "image.properties.trigger": "Propiedades",
  "image.properties.trigger.tooltip": "Fijar propiedades de imagen adicionales",
  "inline.comment.sidebar.navigate.next.description": "Próximo comentario alineado",
  "inline.comment.sidebar.navigate.previous.description": "Comentario alineado anterior",
  "inline.comments.GROW-1507.dialog.close.label": "Cerrar",
  "inline.comments.GROW-1507.dialog.content": "¿Conoces los comentarios alineados?<br>Los puedes usar para revisar, añadiéndolos a una parte específica del documento.",
  "inline.comments.GROW-1507.dialog.header": "Comentarios alineados",
  "inline.comments.GROW-1507.dialog.ok.label": "Entendido",
  "inline.comments.GROW-1507.dialog.showme.label": "Muéstrame",
  "inline.comments.GROW-1507.dialog.title": "SUGERENCIA SOBRE COMENTARIOS",
  "inline.comments.batch.email.view": "Ver comentario",
  "inline.comments.create.placeholder": "escribe un comentario…",
  "inline.comments.create.reply.placeholder": "Responder",
  "inline.comments.date.friendly.about.one.hour.ago": "Hace 1 hora",
  "inline.comments.date.friendly.about.x.days.ago": "Hace {0} días",
  "inline.comments.date.friendly.about.x.hours.ago": "Hace {0} horas",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "recién",
  "inline.comments.date.friendly.one.min.ago": "Hace 1 minuto",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {Hace {0} minuto} other {Hace {0} minutos}}",
  "inline.comments.date.friendly.yesterday": "ayer",
  "inline.comments.delete.confirmation.message": "¿Estás seguro de que deseas eliminar el comentario?",
  "inline.comments.delete.permission": "No tienes permiso para eliminar este comentario.",
  "inline.comments.delete.reply.confirmation.message": "¿Estás seguro de que deseas eliminar esta respuesta?",
  "inline.comments.delete.with.reply": "No puedes eliminar los hilos de comentarios alineados que tienen respuestas.",
  "inline.comments.delete.with.reply.need.reload": "No puedes eliminar este comentario porque hay nuevas respuestas en este hilo. Vuelve a cargar para verlas.",
  "inline.comments.edit.permission": "No tienes permiso para editar este comentario.",
  "inline.comments.editor.lost": "Tu comentario se perderá.",
  "inline.comments.editor.timeout": "El editor no se cargó correctamente. {0}Vuelve a cargar la página {1}para intentar nuevamente.",
  "inline.comments.expand.replies": "{0} respuestas más",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Tu comentario está vacío. Añade la información y haz clic en Guardar.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Error en la comprobación de Captcha",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Comprobación de Captcha correcta",
  "inline.comments.fabric.editor.error.create.not.permitted": "Tu configuración de los permisos no te permite crear comentarios. Pregunta a tu administrador si necesitas esta función.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Tu configuración de los permisos no te permite eliminar comentarios. Pregunta a tu administrador si necesitas esta función.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Tu configuración de los permisos no te permite editar comentarios. Pregunta a tu administrador si necesitas esta función.",
  "inline.comments.fabric.editor.error.invalid.selection": "No se puede crear el comentario. Crea tu aspecto destacado en textos más exclusivos para distinguir la selección y que tu comentario se asigne al contenido correcto.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Tu configuración de los permisos no te permite resolver comentarios. Pregunta a tu administrador si necesitas esta función.",
  "inline.comments.fabric.editor.error.unexpected": "Se ha producido un error al guardar este comentario. Cierra el comentario o actualiza la página, e intenta volver a añadirlo.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Tu configuración de los permisos no te permite ver el comentario. Pregunta a tu administrador si necesitas esta función.",
  "inline.comments.fabric.inline.button.cancel": "Cancelar",
  "inline.comments.fabric.inline.button.save": "Guardar",
  "inline.comments.fabric.sidebar.loading.error": "Se ha producido un error. Cierra la ventana de comentario y vuelve a intentarlo.",
  "inline.comments.likes.error": "No se pueden actualizar los Me gusta.",
  "inline.comments.likes.like": "Me gusta",
  "inline.comments.likes.unlike": "Deshacer me gusta",
  "inline.comments.navigation.index.of": "{0} de {1}",
  "inline.comments.notification.email.reopened": "Reabierto",
  "inline.comments.notification.email.resolved": "Resuelto",
  "inline.comments.notification.email.view": "Ver comentario",
  "inline.comments.resolve.permission": "No tienes permiso para resolver este comentario.",
  "inline.comments.resolved.dangling.message": "Se resolvió porque {0} {1} eliminó el texto",
  "inline.comments.resolved.dialog.empty": "No hay comentarios resueltos en esta página.",
  "inline.comments.resolved.dialog.message": "¡Este comentario no ha desaparecido para siempre! Puedes ver los comentarios resueltos en cualquier momento.",
  "inline.comments.resolved.dialog.show.me": "Muéstrame",
  "inline.comments.resolved.discovery.button.dismiss": "Entendido",
  "inline.comments.resolved.discovery.content": "¿Tienes algo más para decir? Puedes volver a abrir los comentarios resueltos para continuar la discusión.",
  "inline.comments.resolved.menu.show.replies": "{0} respuestas",
  "inline.comments.resolved.menu.show.reply": "{0} respuesta",
  "inline.comments.resolved.menu.unresolve": "Volver a abrir",
  "inline.comments.resolved.message": "Resuelto por {0} {1}",
  "inline.comments.resolved.view.menu": "Comentarios resueltos",
  "inline.comments.server.edit.error": "No podemos guardar tu edición. Es posible que el comentario haya sido eliminado.",
  "inline.comments.server.error": "No pudimos completar tu solicitud.",
  "inline.comments.server.error.edit.comment": "No podemos editar este comentario. Es posible que el comentario haya sido eliminado.",
  "inline.comments.server.error.edit.reply": "No podemos editar esta respuesta. Es posible que la respuesta haya sido eliminada.",
  "inline.comments.sidebar.cancel": "Cancelar",
  "inline.comments.sidebar.close": "Cerrar",
  "inline.comments.sidebar.comment.empty": "No puedes guardar un comentario vacío.",
  "inline.comments.sidebar.delete": "Eliminar",
  "inline.comments.sidebar.deleted": "Eliminado",
  "inline.comments.sidebar.discard": "Descartar",
  "inline.comments.sidebar.edit": "Editar",
  "inline.comments.sidebar.error.create.comment": "No podemos añadir tu comentario alineado; es posible que la sección que resaltaste contenga una macro o una mención de usuario. Intenta resaltar texto sin formato.",
  "inline.comments.sidebar.error.delete.generic": "Error al eliminar comentario. Consulta los registros de Confluence para ver los errores.",
  "inline.comments.sidebar.error.delete.unauthorised": "No tienes permisos suficientes para eliminar este comentario.",
  "inline.comments.sidebar.error.empty": "Ingresa tu comentario.",
  "inline.comments.sidebar.error.save.comment": "No se pudo guardar el comentario",
  "inline.comments.sidebar.error.save.reply": "No se pudo guardar la respuesta",
  "inline.comments.sidebar.error.stale": "El contenido de la página está desactualizado. {0}Actualiza{1} la página y vuelve a intentarlo.",
  "inline.comments.sidebar.like": "Me gusta",
  "inline.comments.sidebar.pagecomment.success": "El comentario de página se creó correctamente",
  "inline.comments.sidebar.reply": "Responder",
  "inline.comments.sidebar.resolve": "Resolver",
  "inline.comments.sidebar.resolved": "Resuelto",
  "inline.comments.sidebar.save": "Guardar",
  "inline.comments.sidebar.saved": "Guardado",
  "inline.comments.sidebar.shortcuts.close.description": "Cerrar comentario alineado",
  "inline.comments.sidebar.show.resolved.comment": "Mostrar comentarios resueltos",
  "inline.comments.sidebar.tooltip.close.description": "Cerrar barra lateral (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Próximo comentario (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Comentario anterior (P)",
  "inline.comments.templates.create.a.comment": "<strong>comentó</strong> sobre una página",
  "inline.comments.templates.resolved.a.comment": "<strong>resolvió</strong> un comentario",
  "inline.comments.templates.resolved.a.comment.dangling": "eliminó el texto al que se hacía referencia en un comentario alineado, por lo que el comentario se <strong>resolvió</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>volvió a abrir</strong> un comentario",
  "inline.comments.unresolved.message": "Reabierto por {0} {1}",
  "jar.file": "Archivo Java",
  "java.file": "Archivo Fuente Java",
  "jpeg.file": "Archivo JPEG",
  "js.file": "Archivo JavaScript",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Opción",
  "keyboard.shortcut.shift": "Mayús",
  "label.contains.invalid.chars": "<b>{0}</b> contiene caracteres inválidos({1}).",
  "label.name.is.too.long": "Los nombres de etiquetas deben tener menos de {0} caracteres.",
  "labels.dialog.shortcut.tip": "Consejo sobre los atajos: en la vista de página, al presionar <b>{shortcut}</b> también se abre este cuadro de diálogo",
  "labels.none": "Sin etiquetas",
  "labels.title": "Etiquetas",
  "last.saved": "Guardada por última vez",
  "likes.bethefirst": "Sé el primero al que le gusta esto",
  "likes.follow": "Seguir",
  "likes.following": "Siguiendo a",
  "likes.like": "Me gusta",
  "likes.peoplewholikethis": "A la gente le gusta esto",
  "likes.summary.1.non-promoted": "A {0} le gusta esto",
  "likes.summary.1.promoted": "A {0} le gusta esto",
  "likes.summary.1.promoted.1.non-promoted": "A {0} y a {1} les gusta esto",
  "likes.summary.2.promoted": "A {0} y a {1} les gusta esto",
  "likes.summary.2.promoted.1.non-promoted": "A {0}, a {1} y a {2} les gusta esto",
  "likes.summary.3.promoted": "A {0}, a {1} y a {2} les gusta esto",
  "likes.summary.3.promoted.1.non-promoted": "A {0}, {1}, {2} y {3} les gusta esto",
  "likes.summary.you": "A usted le gusta esto",
  "likes.summary.you.1.non-promoted": "A usted y a {0} les gusta esto",
  "likes.summary.you.1.promoted": "A usted y a {0} les gusta esto",
  "likes.summary.you.1.promoted.1.non-promoted": "A usted, a {0} y a {1} les gusta esto",
  "likes.summary.you.2.promoted": "A usted, a {0} y a {1} les gusta esto",
  "likes.summary.you.2.promoted.1.non-promoted": "A usted, a {0}, a {1} y a {2} les gusta esto",
  "likes.summary.you.3.promoted": "A usted, a {0}, a {1} y a {2} les gusta esto",
  "likes.summary.you.3.promoted.1.non-promoted": "A usted, a {0}, a {1}, a {2} y a {3} les gusta esto",
  "likes.unlike": "Ya no me gusta",
  "limited.mode.existing.editor.body": "En estos momentos, la edición colaborativa está fuera de línea y {0} está editando esta página. Vuelva a intentarlo en unos minutos.",
  "link.browser.advanced.desc1": "Para añadir un enlace a una nueva página, escriba el título de la página deseada.",
  "link.browser.advanced.desc2": "Para insertar un enlace ancla, escriba #nombredeancla.",
  "link.browser.advanced.error.internal.error": "Se ha producido un error interno del servidor",
  "link.browser.advanced.error.not.link": "El marcado proporcionado no es un marcado de enlace válido",
  "link.browser.advanced.error.unknown.shortcut": "{0} no es un atajo reconocido",
  "link.browser.advanced.error.unknown.space": "{0} no es un espacio reconocido",
  "link.browser.advanced.title": "Aquí puede insertar un enlace en la página usando <a href=\"{0}\" target=\"_blank\">marcado wiki</a>.",
  "link.browser.autocomplete.hint": "Sugerencia: escriba \"[\" en el editor para ver una lista de páginas sugeridas e insertar un enlace.",
  "link.browser.cancel.button": "Cancelar",
  "link.browser.edit.button": "Insertar",
  "link.browser.edit.title": "Editar enlace",
  "link.browser.file.attach": "Subir archivo",
  "link.browser.file.attach.desc": "Vincular a un archivo adjunto a esta página o adjuntar uno nuevo.",
  "link.browser.file.attach.upload.in.progress": "Carga en curso…",
  "link.browser.file.browse.button": "Explorar",
  "link.browser.files.none": "No hay archivos en esta página.",
  "link.browser.insert.button": "Insertar",
  "link.browser.insert.title": "Insertar enlace",
  "link.browser.link": "Enlace",
  "link.browser.link.alias": "Texto de enlace",
  "link.browser.link.image.label": "Imagen de enlace",
  "link.browser.location": "Ubicación del enlace",
  "link.browser.recently.viewed.load.error": "Ocurrió un error al cargar las páginas vistas recientemente",
  "link.browser.recently.viewed.none": "No tiene contenido visto recientemente.",
  "link.browser.search": "Buscar",
  "link.browser.search.for": "Buscar",
  "link.browser.search.invalid": "Términos de búsqueda inválidos",
  "link.browser.search.results.load.error": "Se encontró un error durante la búsqueda",
  "link.browser.search.results.none": "No se hallaron resultados de búsqueda.",
  "link.browser.space.all": "Todo el contenido",
  "link.browser.tab.name.advanced": "Avanzado",
  "link.browser.tab.name.files": "Archivos",
  "link.browser.tab.name.recently.viewed": "Vistas recientemente",
  "link.browser.tab.name.search": "Búsqueda",
  "link.browser.tab.name.weblinks": "Enlace web",
  "link.browser.table.file.comment": "Comentario",
  "link.browser.table.file.name": "Nombre",
  "link.browser.table.file.size": "Tamaño",
  "link.browser.table.last.modified": "Modificado por última vez",
  "link.browser.table.space": "Espacio",
  "link.browser.table.title": "Título",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Página web, correo electrónico o cualquier otra dirección en Internet",
  "link.browser.web.link.label": "Dirección",
  "location.name": "Ubicación",
  "login.button": "Iniciar sesión",
  "look.and.feel": "Apariencia Visual",
  "marketplace.link.name": "Aplicaciones en Marketplace",
  "more.word.action": "Más acciones",
  "more.word.capitalised": "Más",
  "moveblogpost.already.exists.in.target.space": "Ya existe una entrada de blog con el mismo título y fecha en el espacio seleccionado.",
  "moveblogpost.source.notfound": "No se halló la entrada de blog de origen.",
  "moveblogpost.target.space.notfound": "No se encontró el espacio de destino.",
  "moveblogpost.target.space.same.as.origin": "No puedes mover una entrada de blog al espacio en el que ya se encuentra.",
  "multimedia.file": "Archivo Multimedia",
  "my.drafts.mainBanner": "Capta ideas con rapidez",
  "my.drafts.subBanner": "Crea una página y plasma tus ideas. Si no quieres publicarlas todavía, cierra la página y ya está. La guardaremos automáticamente en forma de borrador para que puedas retomarla cuando quieras. ",
  "my.spaces.tooltip.add": "Añadir a mis espacios",
  "my.spaces.tooltip.remove": "Quitar de mis espacios",
  "name.word": "Nombre",
  "nav.controller.activity": "Actividad",
  "nav.controller.activity.feed": "Fuente de actividades",
  "nav.controller.all.spaces": "Espacios",
  "nav.controller.discover": "Descubrir",
  "nav.controller.my.spaces": "Mis espacios",
  "nav.controller.my.spaces.anchor": "Todos",
  "nav.controller.my.spaces.blank": "Ten tus espacios más útiles a mano. Toca la estrella junto a cada espacio para que aparezca aquí.",
  "nav.controller.my.spaces.blank.callToAction": "Buscar espacios",
  "nav.controller.projects": "Proyectos",
  "nav.controller.recent": "Páginas recientes",
  "nav.controller.your.work": "Su trabajo",
  "navigation.app.switcher.apps": "Aplicaciones",
  "navigation.app.switcher.dont.show.again": "Dont show again",
  "navigation.app.switcher.edit": "Editar",
  "navigation.app.switcher.error-message": "Error al obtener los enlaces de aplicación.",
  "navigation.app.switcher.home.description": "Página principal",
  "navigation.app.switcher.img.alt": "Cambio de aplicación",
  "navigation.app.switcher.loading": "Cargando...",
  "navigation.app.switcher.recent": "Reciente",
  "navigation.app.switcher.recent-containers-confluence-space": "Espacio",
  "navigation.app.switcher.recent-containers-jira-project": "Proyecto",
  "navigation.app.switcher.try.other.apps": "Probar otras aplicaciones",
  "navigation.app.switcher.use.confluence": "Usar Confluence",
  "navigation.app.switcher.use.jira": "Usar Jira",
  "navigation.label-for-bell": "Notificaciones",
  "navigation.label-for-global-people-icon": "Directorio de personas",
  "navigation.notification-drawer-title": "Notificaciones del inicio",
  "navigation.people-drawer-title": "Directorio de personas",
  "navlink.edit": "{0}E{1}ditar",
  "network.page": "Página de red",
  "no.drafts.found": "No se encontraron borradores.",
  "no.matches.mainBanner": "No podemos hallar nada en relación con",
  "no.name": "No",
  "no.permission": "Sin Permisos",
  "no.spaces.found": "No se encontraron espacios.",
  "not.watching.anything": "No está vigilando nada.",
  "notification.start": "Comenzar a vigilar",
  "notification.stop": "Para de Vigilar",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Comentario insertado|1<Comentarios insertados}",
  "notifications.batch.inline.comment.new.lozenge": "nuevo",
  "notifications.batch.inline.comment.reopened.lozenge": "ha reabierto",
  "notifications.batch.inline.comment.resolved": "$user $lozenge un comentario",
  "notifications.batch.inline.comment.resolved.lozenge": "ha resuelto",
  "notifications.preferences.desc": "Puede configurar sus opciones de notificación por correo electrónico en la página de <a href=\"viewmyemailsettings.action\">configuración de correo electrónico</a>.",
  "onboarding-choose-a-space.description": "Elige uno de los espacios actuales de tu equipo. Podrás crear más espacios más adelante.",
  "onboarding-choose-a-space.title": "Elige un espacio para trabajar en él",
  "onboarding.choose-a-space.backBtn": "Atrás",
  "onboarding.choose-a-space.nextBtn": "Siguiente",
  "onboarding.choose-a-space.selectLabel": "Nombre del espacio",
  "onboarding.choose-a-space.selectPlaceholder": "Selecciona el nombre del espacio",
  "onboarding.create-a-space.backBtn": "Volver",
  "onboarding.create-a-space.description": "Comienza con un espacio para tu equipo o proyecto actual. Podrás crear más espacios más adelante.",
  "onboarding.create-a-space.inputTextLabel": "Nombre",
  "onboarding.create-a-space.inputTextPlaceholder": "Gemas de cristal",
  "onboarding.create-a-space.invalidMessage": "Los nombres de espacio deben tener, al menos, una letra o número.",
  "onboarding.create-a-space.nextBtn": "Siguiente",
  "onboarding.create-a-space.title": "Crea un espacio para trabajar en él",
  "onboarding.dialog.existing-user.cancel": "No mostrar sugerencias",
  "onboarding.dialog.existing-user.confirm": "Vayamos",
  "onboarding.dialog.existing-user.content": "Hemos cambiado algunas cosas de lugar para ofrecerle una mejor experiencia con el panel y hemos activado algunas sugerencias para ayudarlo a comenzar.",
  "onboarding.dialog.existing-user.title": "¡Bienvenido a su nuevo panel!",
  "onboarding.dialog.new-user.cancel": "No mostrar sugerencias",
  "onboarding.dialog.new-user.confirm": "Vayamos",
  "onboarding.dialog.new-user.content": "El panel es la página de inicio que lo ayuda a desplazarse por Confluence.<br/>Activamos algunas sugerencias para ayudarlo a comenzar.",
  "onboarding.dialog.new-user.title": "¡Bienvenido al panel!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Haz clic en inicio para cambiar a una lista de páginas u otro contenido.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Todavía puedes encontrar tu lista de blogs aquí",
  "onboarding.navigation.dont.show": "No mostrar más consejos",
  "onboarding.navigation.global.sidebar.byline": "So no matter where you are in Confluence, the important things are just one click away.",
  "onboarding.navigation.global.sidebar.heading": "Esta barra lateral es ahora universal onboarding.navigation.global.sidebar.byline=Así que da igual dónde en Confluence estés, tendrás todo lo importante a un solo clic.",
  "onboarding.navigation.ok": "Vale, entendido",
  "onboarding.navigation.page.tip.page.tree.byline": "Haz clic en inicio para cambiar a una lista de blogs u otro contenido.",
  "onboarding.navigation.page.tip.page.tree.heading": "Your page tree can still be found here",
  "onboarding.navigation.space.tip.space.tabs.byline": "La página de inicio de tu espacio es ahora la vista general y tus páginas, publicaciones de blog y demás contenidos tienen cada uno su propia pestaña.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Ahora, el contenido está organizado en pestañas",
  "onboarding.tooltip.actions.done": "¡Entendido!",
  "onboarding.tooltip.actions.next": "Siguiente",
  "onboarding.tooltip.actions.skip": "Saltar consejos",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Accede directamente a tus espacios favoritos o visita la lista de todos los espacios.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Tus espacios favoritos con solo mover un dedo",
  "onboarding.tooltip.existing-user.sidebar.content": "Busque nuevas páginas y vuelva a su trabajo reciente desde la nueva barra lateral.",
  "onboarding.tooltip.existing-user.sidebar.title": "Descubra más con la barra lateral",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Accede directamente a tus espacios favoritos o visita la lista de todos los espacios.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Tus espacios favoritos con solo mover un dedo",
  "onboarding.tooltip.new-user.sidebar.content": "Busque nuevas páginas y vuelva a su trabajo reciente desde la barra lateral.",
  "onboarding.tooltip.new-user.sidebar.title": "Descubra más con la barra lateral",
  "onboarding.tooltip.saved-for-later.content": "Tus páginas favoritas aparecen ahora con su nuevo nombre. Guardado para más tarde.",
  "onboarding.tooltip.saved-for-later.title": "Adiós, Favoritos; hola, Guardado para más tarde",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ Añadir más correos electrónicos",
  "onboarding.who-is-on-your-team.description": "Confluence es mejor cuando tus compañeros de equipo crean, debaten y colaboran contigo en el trabajo.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Añade la dirección de correo electrónico",
  "onboarding.who-is-on-your-team.enableDRS": "Permite que cualquiera que tenga una dirección de correo electrónico {domain} verificada se una a tu sitio (te avisaremos siempre que alguien se una).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Brinda a los usuarios la posibilidad de invitar a otras personas a tu sitio.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Introduce una dirección de correo electrónico válida",
  "onboarding.who-is-on-your-team.nextBtn": "Siguiente",
  "onboarding.who-is-on-your-team.title": "¿Quién está en tu equipo?",
  "only.personal.labels.permitted": "Solo tiene permisos para añadir etiquetas personales en esta página.",
  "org.randombits.confluence.toc.toc.label": "Tabla de contenidos",
  "page.already.exists": "Ya existe otra página con el mismo titulo en el espacio de destino",
  "page.already.exists.inspace": "La página '{'0'}' ya existe en el espacio '{'1'}'. Debes cambiar el título de la página antes de moverla.",
  "page.change": "¿Qué has cambiado?",
  "page.comments.saved.dialog.message": "El comentario se ha guardado como comentario de página.",
  "page.comments.sidebar.warning": "No podemos añadir un comentario alineado a este contenido. Lo añadiremos como comentario de página.",
  "page.descendent.already.exists": "Una página descendiente tiene el mismo título que otra página en el espacio seleccionado.",
  "page.permissions.menu.item.title": "Restricciones",
  "page.permissions.menu.item.title.tooltip": "Editar las restricciones",
  "page.tree.blankExperience.mainBanner": "Aquí solo hay potencial.",
  "page.tree.blankExperience.subBanner": "Llena este espacio con notas de reuniones, requisitos de producto, artículos de instrucciones o cualquier otro contenido.",
  "page.watch.instruction": "Para vigilar una página o entrada de blog: abra el menú de ‘Herramientas’ y haga clic en ‘Vigilar’.",
  "page.watches": "Vigilancia de Páginas",
  "page.word": "Página",
  "pages.navigation.discovery.body.html": "Haz clic en <strong>Páginas</strong> para mostrar el árbol de la página y ver páginas en este espacio.",
  "pages.navigation.discovery.header": "El árbol de la página ahora reside aquí",
  "pages.show.all": "Mostrar todas las páginas",
  "pages.word": "Páginas",
  "pagetree.dragndrop.failed.action.visitsupport": "Visita la página de asistencia de Atlassian",
  "pagetree.dragndrop.failed.description": "Actualiza la página y vuelve a intentarlo. Si el problema continúa, háznoslo saber a través del siguiente enlace.",
  "pagetree.dragndrop.failed.title": "Algo ha ido mal.",
  "pagetree.failed.load.content": "Error al cargar el árbol de páginas",
  "pagetree.failed.load.tooltip": "Aguanta un poco, lo estamos solucionando.",
  "parent.page.invalid.for.space": "No hay ninguna página con el titulo <b>{0}</b> en el espacio <b>{1}</b>.",
  "parent.page.name": "Página principal",
  "pdf.file": "Archivo PDF",
  "people.directory.name": "Gente",
  "period.lastSevenDays": "En la última semana",
  "period.lastThirtyDays": "En el último mes",
  "period.older": "Hace más de un mes",
  "period.today": "Hoy",
  "period.yesterday": "Ayer",
  "permission.owner.not.in.group": "Solo puede otorgar permisos de página a grupos a los cuales pertenece",
  "permission.owner.not.set": "Debe elegir un propietario para el permiso",
  "permissions.comment": "Define quien puede ver y editar la página. Puede restringir estos permisos a usted mismo o a un grupo de usuarios.",
  "permissions.edit.title": "Editar",
  "permissions.select.nopermissions": "No definidos",
  "permissions.view.title": "Ver",
  "person.follow": "Seguir",
  "person.follow.stop": "Dejar de seguir",
  "personal.spaces": "Espacios personales",
  "placeholder.placeholdertext.label": "Texto de marcador de posición",
  "placeholder.replacementtext.label": "Texto de reemplazo",
  "please.enter.a.label": "Por favor, introduzca una etiqueta.",
  "png.file": "Archivo PNG",
  "popular.stream.mainBanner": "No están pasando muchas cosas... Todavía",
  "popular.stream.subBanner": "Todo está tranquilo ahora, pero una vez que su equipo comience a crear, las páginas y archivos más populares aparecerán aquí.",
  "popular.stream.subBanner2": "¡Que comience la fiesta!",
  "popular.stream.title": "Popular",
  "posted.word": "Publicado",
  "powerpoint.file": "Presentación de Microsoft PowerPoint",
  "powerpoint.macro.file": "Presentación de Microsoft Powerpoint habilitada para macros",
  "powerpoint.slideshow.file": "Presentación de Microsoft Powerpoint",
  "powerpoint.template.file": "Plantilla de Microsoft Powerpoint",
  "powerpoint97.file": "Presentación de Microsoft Powerpoint 97",
  "powerpoint97.template.file": "Plantilla de Microsoft Powerpoint 97",
  "product.name": "Confluence",
  "profile.page": "Página de Perfil",
  "property.panel.macro.display.inline": "Mostrar en misma línea",
  "property.panel.macro.display.newline": "Mostrar en nueva línea",
  "property.panel.macro.edit": "Editar",
  "property.panel.macro.remove": "Eliminar",
  "property.panel.textplaceholder.display.default": "Texto",
  "property.panel.textplaceholder.display.default.tooltip": "El texto instructivo se reemplaza con contenido vacío cuando una persona escribe.",
  "property.panel.textplaceholder.display.mention": "Mención de usuarios",
  "property.panel.textplaceholder.display.mention.tooltip": "El texto instructivo se reemplaza con personas sugeridas cuando una persona escribe.",
  "property.panel.textplaceholder.remove": "Eliminar",
  "property.panel.variable.display.list": "Lista",
  "property.panel.variable.display.list.tooltip": "Lista desplegable",
  "property.panel.variable.display.string": "Texto",
  "property.panel.variable.display.string.tooltip": "Campo de entrada de texto de una sola línea.",
  "property.panel.variable.display.textarea": "Texto multilínea",
  "property.panel.variable.display.textarea.tooltip": "Campo de entrada de texto multilínea.",
  "property.panel.variable.list.values.tooltip": "Ingresar cada elemento de la lista, separar cada uno con una coma.",
  "property.panel.variable.textarea.columns.tooltip": "Cantidad de columnas para mostrar en el campo.",
  "property.panel.variable.textarea.rows.tooltip": "Cantidad de filas para mostrar en el campo.",
  "quick.comment.placeholder.message": "Escriba un comentario …",
  "quick.reload.edit": "Nuevas ediciones de la página",
  "quick.reload.edit.by": "de",
  "quick.reload.edit.more": "y {0} más",
  "quick.reload.edit.one.more": "y 1 más",
  "quick.reload.edits": "{0} nuevas ediciones",
  "quick.reload.newcomments": "{0} nuevos comentarios",
  "quick.reload.newpagecomment": "Nuevo comentario",
  "quick.reload.reload": "Volver a cargar la página",
  "recently-updated-content-list.commented.new": "Comentado {time}",
  "recently-updated-content-list.created.new": "Creado {time}",
  "recently-updated-content-list.edited.new": "Actualizado {time}",
  "recently.viewed.mainBanner": "Es hora de hacer historia",
  "recently.viewed.subBanner": "Aún no ha visitado ninguna página, pero cuando lo haga, la colocaremos aquí para que pueda regresar a ella con rapidez.",
  "recently.viewed.subBanner2": "Visita un <b>espacio</b> ahora y echa un vistazo a tu alrededor.",
  "recently.viewed.title": "Visitados recientemente",
  "recently.worked.mainBanner": "Termine esa obra maestra",
  "recently.worked.subBanner": "Aún no ha creado ni editado nada, pero cuando lo haga, lo colocaremos aquí para que pueda retomarlo donde lo dejó con facilidad.",
  "recently.worked.subBanner2": "Ahora vaya y cree su mejor trabajo.",
  "recently.worked.title": "Con trabajo reciente",
  "remove.comment.confirmation.message": "¿Está seguro de que desea eliminar el comentario?",
  "remove.label": "Eliminar etiqueta",
  "resize.image.dialog.title": "Cambiar tamaño de imagen",
  "restore.this.version": "Restaurar",
  "result.grid.column.content.last.modified": "Última modificación",
  "resume.editing": "Continuar",
  "return.to.page.info": "Volver a la información de página",
  "satisfaction.survey.reaction.amazing": "Extraordinaria",
  "satisfaction.survey.reaction.bad": "Mala",
  "satisfaction.survey.reaction.great": "Estupenda",
  "satisfaction.survey.reaction.okay": "Buena",
  "satisfaction.survey.reaction.terrible": "Terrible",
  "save.name": "Guardar",
  "scheme.desc.custom": "Un esquema de colores personalizado que puede ser editado.",
  "scheme.desc.global": "Este esquema de colores usará el esquema de colores definido globalmente en este espacio.",
  "scheme.title.custom": "Esquema de color personalizado",
  "scheme.title.global": "Esquema de color global",
  "search.drawer.recently.viewed": "Visto recientemente",
  "search.drawer.recently.viewed.spaces": "Espacios recientes",
  "search.name": "Buscar",
  "settings.name": "Preferencias generales",
  "share.button.restriction.message.text": "Las restricciones de esta página pueden impedir que los usuarios la vean o editen",
  "share.button.text": "Compartir",
  "show.more.blogposts": "Ver más entradas de blog",
  "sidebar.avatar.picker.upload.error": "Ha habido un error actualizando los detalles del espacio",
  "sidebar.main.back.to.overview": "Volver a la vista general",
  "sidebar.main.back.to.space": "Volver al espacio",
  "sidebar.main.blog": "Blog",
  "sidebar.main.quick.links": "Accesos directos de espacio",
  "sidebar.main.settings": "Configuración de espacio",
  "sidebar.main.shortcuts": "Enlaces",
  "sidebar.main.wiki": "Páginas",
  "site-settings.templates-and-blueprints.edit-button-label": "Editar",
  "space.404.banner.title": "¡Vaya! Ha encontrado un enlace roto.",
  "space.404.go.back": "Volver a la",
  "space.404.go.to": "Ir a la",
  "space.404.home.page": "página de inicio",
  "space.404.previous.page": "página anterior",
  "space.create": "Crear espacio",
  "space.home.blog.blankExperience.mainBanner": "¿Quieres compartir algo?",
  "space.home.blog.blankExperience.subBanner": "Las entradas de blog son una fantástica forma de compartir comunicados, informes de estado u otras novedades importantes con tu equipo.",
  "space.home.overview.blankExperience.mainBanner": "Bueno, esto es un poco embarazoso.",
  "space.home.overview.blankExperience.subBanner": "Esta página no tiene una página de inicio, así que no hay nada que mostrar aquí. Gatito llorando.",
  "space.home.overview.blankExperience.subBanner2": "¡Añade ya una página de inicio para ordenarlo todo y utilízala para mostrar a tus visitantes qué es este espacio!",
  "space.not.exists": "El espacio que has definido no existe.",
  "space.personal.name": "Espacio personal",
  "space.set.space.home": "Establecer inicio del espacio",
  "space.watch.instruction": "Para ver páginas o entradas de blog en espacios, haz clic en 'Páginas' o 'Blog' en la barra lateral del espacio.",
  "space.watches": "Ver los espacios",
  "spaces.all": "Todos los espacios",
  "spaces.lookandfeel.help": "Aquí puedes personalizar la apariencia de este espacio de Confluence.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Nota:</span> <i>toda modificación realizada aquí anulará la gama de colores predeterminada y los decorators predeterminados configurados por tu administrador.</i>",
  "spaces.word": "Espacios",
  "starred.mainBanner": "No hay nada para ver aquí... Todavía",
  "starred.spaces.tooltip.add": "Añadir este espacio a Favoritos",
  "starred.spaces.tooltip.remove": "Quitar este espacio de Favoritos",
  "starred.subBanner": "Dale al <b>icono de estrella</b> para guardar una página para más adelante. La dejaremos aquí para que la puedas encontrar cuando la necesites.",
  "starred.title": "Guardado para después.",
  "status.lozenge.draft": "Borrador",
  "status.lozenge.unpublished": "Cambios no publicados",
  "submit.name": "Enviar",
  "super-admin.banner.exit": "Dejar de usar la clave de administrador",
  "super-admin.banner.message": "Estás usando la llave de administrador, que te da acceso temporal a contenido restringido.",
  "switch.apps": "Cambiar de aplicación",
  "system.help.legal": "Asuntos legales",
  "team.create.flag.error.description": "No hemos podido crearte un equipo. Vuelve a intentarlo pronto.",
  "team.create.flag.error.title": "¡Vaya! Algo ha ido mal.",
  "team.created.flag.description": "{membersCount, plural, one {Has invitado a {membersCount} persona al equipo '{'teamName'}'} other {Has invitado a {membersCount} personas al equipo '{'teamName'}'}}",
  "team.created.flag.title": "Se ha creado un nuevo equipo",
  "team.created.flag.view": "Ver equipo",
  "template.variables.fabric.section.message": "En esta plantilla se utilizan variables. Una vez introducidas, la información que proporciones formará parte del contenido de tu nueva página.",
  "templates.name": "Plantillas",
  "text.file": "Archivo de Texto",
  "text.selected": "Seleccionado",
  "tinymce.advanced.block": "Formato",
  "tinymce.advanced.blockquote": "Citar",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Negrita",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Lista de viñetas",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Mayús+B",
  "tinymce.advanced.charmap_desc": "Símbolo",
  "tinymce.advanced.forecolor_desc": "Selecciona el color del texto",
  "tinymce.advanced.formatting_desc": "Formato",
  "tinymce.advanced.h1": "Título 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Título 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Título 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Título 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Título 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Título 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Títulos 1 a 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Regla horizontal",
  "tinymce.advanced.indent_desc": "Aplicar sangría",
  "tinymce.advanced.italic_desc": "Cursiva",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Alinear al centro",
  "tinymce.advanced.justifyfull_desc": "Justificar",
  "tinymce.advanced.justifyleft_desc": "Alinear a la izquierda",
  "tinymce.advanced.justifyright_desc": "Alinear a la derecha",
  "tinymce.advanced.numlist_desc": "Lista numerada",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Mayús+N",
  "tinymce.advanced.outdent_desc": "Anular sangría",
  "tinymce.advanced.paragraph": "Párrafo",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "Con formato previo",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Rehacer",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "Tachado",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Mayús+S",
  "tinymce.advanced.sub_desc": "Subíndice",
  "tinymce.advanced.sup_desc": "Superíndice",
  "tinymce.advanced.tasklist_desc": "Lista de tareas",
  "tinymce.advanced.tasklist_shortcut": "[ luego ]",
  "tinymce.advanced.underline_desc": "Subrayar",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "Deshacer",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "Desvincular",
  "tinymce.atlassian.help": "Ayuda",
  "tinymce.atlassian.insert_menu": "Insertar",
  "tinymce.atlassian.insert_menu.charmap_desc": "Insertar símbolo",
  "tinymce.atlassian.insert_menu.content_desc": "Insertar contenido",
  "tinymce.atlassian.insert_menu.hr_desc": "Insertar regla horizontal (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Insertar macro",
  "tinymce.atlassian.insert_menu.tooltip": "Insertar más contenido",
  "tinymce.atlassian.monospace": "Monoespacio",
  "tinymce.atlassian.monospace_desc": "Dar formato a texto con fuente monoespaciada",
  "tinymce.atlassian.more_menu": "Más",
  "tinymce.atlassian.remove_formatting": "Borrar formato",
  "tinymce.atlassian.remove_formatting_desc": "Borra formato en texto seleccionado",
  "tinymce.auiwindowmanager.cancel": "Cancelar",
  "tinymce.auiwindowmanager.ok": "Aceptar",
  "tinymce.autocomplete.web.resource.name": "Recursos web de autocompletar de Confluence",
  "tinymce.autocomplete.web.resource.only.name": "Recursos web de autocompletar de Confluence sin dependencias",
  "tinymce.charmap.web.resource.name": "Recursos web de mapa de caracteres de TinyMce",
  "tinymce.charmap_dlg.title": "Insertar símbolo",
  "tinymce.colorpicker.color": "Color",
  "tinymce.colorpicker.more_colors": "Más colores",
  "tinymce.colorpicker.picker_tab": "Selector",
  "tinymce.colorpicker.picker_title": "Selector de colores",
  "tinymce.colorpicker.title": "Seleccionar un color",
  "tinymce.colorpicker.web.resource.name": "Recursos web del selector de colores de Confluence",
  "tinymce.confluence.conf_emoji": "Emoticono",
  "tinymce.confluence.conf_emoticon": "Emoticono",
  "tinymce.confluence.conf_emoticon_desc": "Insertar emoticono",
  "tinymce.confluence.conf_file": "Archivos e imágenes",
  "tinymce.confluence.conf_file_desc": "Insertar archivos e imágenes",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Imagen",
  "tinymce.confluence.conf_image_desc": "Insertar imagen",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Enlace",
  "tinymce.confluence.conf_link_desc": "Insertar enlace",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Macro",
  "tinymce.confluence.conf_macro_browser_desc": "Insertar macro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Mayús+A",
  "tinymce.confluence.conf_media": "Imagen/multimedia",
  "tinymce.confluence.conf_other_macros_desc": "Otras macros...",
  "tinymce.confluence.conf_shortcuts_help": "Ayuda de métodos abreviados de teclado",
  "tinymce.confluence.conf_tasklist": "Lista de tareas",
  "tinymce.confluence.conf_tasklist_desc": "Insertar lista de tareas",
  "tinymce.confluence.conf_tasklist_shortcut": "[ luego ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Marcado",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Insertar",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Wiki de Confluence",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Errores de conversión de marcado wiki",
  "tinymce.confluence.conf_wikimarkup_desc": "Insertar marcado",
  "tinymce.confluence.conf_wikimarkup_hint": "Sugerencia: también puede ingresar marcado wiki directamente en el editor, donde se le dará formato a medida que escribe.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Ingrese wiki markup o markdown a continuación. Confluence convertirá su contenido en formato de editor y lo insertará en la página.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Vista previa",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Mayús+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "El servidor tardó demasiado en convertir el marcado wiki. Es posible que este sea un problema temporal, por lo que puede volver a intentarlo.",
  "tinymce.confluence.files": "Archivos",
  "tinymce.confluence.help_desc": "Ayuda",
  "tinymce.confluence.htmlsource": "Código Fuente",
  "tinymce.confluence.htmlsource_desc": "Ver código fuente HTML",
  "tinymce.confluence.layout.menu": "Diseño de página",
  "tinymce.confluence.layout.none": "Ningún diseño",
  "tinymce.confluence.layout.three_col": "Tres columnas",
  "tinymce.confluence.layout.three_col_sidebars": "Tres columnas (barras laterales izquierda y derecha)",
  "tinymce.confluence.layout.three_col_simple": "Tres columnas (simples)",
  "tinymce.confluence.layout.two_col": "Dos columnas",
  "tinymce.confluence.layout.two_col_left": "Dos columnas (barra lateral izquierda)",
  "tinymce.confluence.layout.two_col_right": "Dos columnas (barra lateral derecha)",
  "tinymce.confluence.layout.two_col_simple": "Dos columnas (simples)",
  "tinymce.confluence.layout.two_col_simple_left": "Dos columnas (simples, barra lateral izquierda)",
  "tinymce.confluence.layout.two_col_simple_right": "Dos columnas (simple, barra lateral derecha)",
  "tinymce.confluence.macro_insert": "Insertar macro '{'0'}'",
  "tinymce.confluence.macro_other": "Otras macros",
  "tinymce.confluence.macro_other_desc": "Abrir el explorador de macros",
  "tinymce.confluence.placeholder.inline.tasks": "Escriba su tarea aquí, usando \"@\" para asignarla a un usuario y \"//\" para seleccionar una fecha de vencimiento",
  "tinymce.confluence.preview": "Vista preliminar",
  "tinymce.confluence.preview_shortcut": "Ctrl+Mayús+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Configuración del editor",
  "tinymce.confluence_dlg.insertbutton.title": "Insertar",
  "tinymce.confluence_dlg.insertimage.title": "Insertar imagen",
  "tinymce.confluence_dlg.insertlink.title": "Insertar enlace",
  "tinymce.emotions.emotions_desc": "Emoticonos",
  "tinymce.emotions.web.resource.name": "Recursos web de emociones de TinyMce",
  "tinymce.emotions_dlg.add": "Signo de más (+)",
  "tinymce.emotions_dlg.biggrin": "Gran sonrisa :D",
  "tinymce.emotions_dlg.broken_heart": "Corazón roto </3",
  "tinymce.emotions_dlg.check": "Tic (/)",
  "tinymce.emotions_dlg.desc": "Emoticonos",
  "tinymce.emotions_dlg.error": "Error (x)",
  "tinymce.emotions_dlg.forbidden": "Signo de menos (-)",
  "tinymce.emotions_dlg.heart": "Corazón <3",
  "tinymce.emotions_dlg.help_16": "Signo de interrogación (?)",
  "tinymce.emotions_dlg.information": "Info (i)",
  "tinymce.emotions_dlg.lightbulb": "Bombilla apagada (off)",
  "tinymce.emotions_dlg.lightbulb_on": "Bombilla encendida (on)",
  "tinymce.emotions_dlg.sad": "Triste :(",
  "tinymce.emotions_dlg.smile": "Sonrisa :)",
  "tinymce.emotions_dlg.star_blue": "Estrella azul (*b)",
  "tinymce.emotions_dlg.star_green": "Estrella verde (*g)",
  "tinymce.emotions_dlg.star_red": "Estrella roja (*r)",
  "tinymce.emotions_dlg.star_yellow": "Estrella amarilla (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Pulgar hacia abajo (n)",
  "tinymce.emotions_dlg.thumbs_up": "Pulgar hacia arriba (y)",
  "tinymce.emotions_dlg.title": "Insertar emoticono",
  "tinymce.emotions_dlg.tongue": "Lengua :p",
  "tinymce.emotions_dlg.warning": "Advertencia (!)",
  "tinymce.emotions_dlg.wink": "Guiño ;)",
  "tinymce.fabric.migration.dialog.action": "Seguir editando",
  "tinymce.fabric.migration.dialog.content": "No te preocupes, los cambios no se han perdido. Solo teníamos que actualizar la página.",
  "tinymce.fabric.migration.dialog.title": "Acabamos de editar tu experiencia en materia de edición",
  "tinymce.formatting.paragraph": "Texto normal",
  "tinymce.full_screen.toolbar_item": "Pantalla completa",
  "tinymce.full_screen.toolbar_item_title": "Iniciar pantalla completa del editor",
  "tinymce.hints.autoformat.code": "Sugerencia: Escribe \"<strong>'{{'code'}}'</strong>\" para insertar rápidamente un texto con espaciado simple.",
  "tinymce.hints.autoformat.heading1": "Sugerencia: Escriba \"<strong>h1. Título</strong>\" para insertar rápidamente un título 1.",
  "tinymce.hints.autoformat.heading3": "Sugerencia: Escriba \"<strong>h3. Título</strong>\" para insertar rápidamente un título 3.",
  "tinymce.hints.dnd": "Sugerencia: puede arrastrar y soltar imágenes y archivos de Office desde su computadora directamente en este editor.",
  "tinymce.hints.drafts": "Sugerencia: Confluence guarda borradores automáticamente. Si alguna vez perdiera una ventana, recupere su trabajo desde el menú \"Nombre de usuario -> Borradores\".",
  "tinymce.hints.insert.bullet.list": "Sugerencia: presione <strong>Ctrl+Mayús+B</strong> para comenzar una lista de viñetas.",
  "tinymce.hints.insert.heading": "Sugerencia: presione <strong>Ctrl+1</strong> para crear un título de nivel 1, <strong>Ctrl+2</strong> para un título de nivel 2, y así sucesivamente.",
  "tinymce.hints.insert.image": "Sugerencia: presione <strong>Ctrl+M</strong> para abrir el explorador de imágenes.",
  "tinymce.hints.insert.image.end": "Sugerencia: presione <strong>Ctrl+Mayús+M</strong> después de una palabra para buscar e insertar imágenes pertinentes.",
  "tinymce.hints.insert.image.on.page": "Sugerencia: escriba \"<strong>!</strong>\" para ver las imágenes adjuntas a la página e insertar una de ellas.",
  "tinymce.hints.insert.image.search": "Sugerencia: escriba \"<strong>!</strong>\" y parte del nombre de una imagen para buscar e insertar la imagen.",
  "tinymce.hints.insert.link": "Sugerencia: presione <strong>Ctrl+K</strong> para abrir el explorador de enlaces.",
  "tinymce.hints.insert.link.end": "Sugerencia: presione <strong>Ctrl+Mayús+K</strong> después de una palabra para buscar y vincular a páginas pertinentes. Vuelva a presionar para obtener más sugerencias.",
  "tinymce.hints.insert.link.newpage": "Sugerencia: escriba \"<strong>[</strong>\" y el título de una nueva página que desee crear para ver una sugerencia de enlace para insertar.",
  "tinymce.hints.insert.link.recently.viewed": "Sugerencia: escriba \"<strong>[</strong>\" para ver una lista de páginas sugeridas e insertar un enlace.",
  "tinymce.hints.insert.link.search": "Sugerencia: escriba \"<strong>[</strong>\" y parte del título de una página para buscar y establecer un enlace a esa página.",
  "tinymce.hints.insert.link.user.mention": "Sugerencia: puede mencionar a alguien en Confluence escribiendo \"<strong>@</strong>\" y luego su nombre.",
  "tinymce.hints.insert.macro": "Sugerencia: presione <strong>Ctrl+ Mayús+A</strong> para abrir el explorador de macros.",
  "tinymce.hints.insert.macro.toc": "Sugerencia: Permita que Confluence le genere una tabla de contenido para esta página. Use \"Insertar -> Tabla de contenido\"",
  "tinymce.hints.insert.newline": "Sugerencia: Escriba <strong>Mayús+ Entrar</strong> para insertar un nuevo párrafo sin espaciado",
  "tinymce.hints.insert.numbered.list": "Sugerencia: presione <strong>Ctrl+Mayús+N</strong> para comenzar una lista numerada.",
  "tinymce.hints.insert.table": "Sugerencia: presione <strong>Ctrl+Mayús+I</strong> para insertar una tabla.",
  "tinymce.hints.insert.wikimarkup": "Sugerencia: el editor convertirá el marcado wiki automáticamente a medida que usted lo escribe.",
  "tinymce.hints.insert.wikimarkup.dialog": "Sugerencia: presione <strong>Ctrl+Mayús+D</strong> para abrir el diálogo de marcado wiki.",
  "tinymce.hints.table.rows.copy": "Sugerencia: presione <strong>Ctrl+Mayús+C</strong> para copiar una fila y <strong>Ctrl+Mayús+V</strong> para pegar una fila en una tabla.",
  "tinymce.hints.table.rows.cut": "Sugerencia: presione <strong>Ctrl+Mayús+X</strong> para cortar una fila y <strong>Ctrl+Mayús+V</strong> para pegar una fila en una tabla.",
  "tinymce.macro.preview.exception": "Ocurrió una excepción al obtener la vista previa de la macro. Excepción: {0}",
  "tinymce.macro.unknownMacro": "La macro '{'0'}' es desconocida. Es posible que se haya eliminado del sistema.",
  "tinymce.popup_blocked": "El explorador bloqueó un elemento emergente abierto por el editor.",
  "tinymce.propertypanel.images.border": "Borde",
  "tinymce.propertypanel.images.border.tooltip": "Mostrar un borde alrededor de la imagen",
  "tinymce.propertypanel.images.large": "Grande",
  "tinymce.propertypanel.images.large.tooltip": "Cambiar el tamaño de la imagen a grande y vincularla a la original",
  "tinymce.propertypanel.images.link.create": "Enlace",
  "tinymce.propertypanel.images.link.create.tooltip": "Vincular esta imagen a otro contenido",
  "tinymce.propertypanel.images.link.edit": "Editar enlace",
  "tinymce.propertypanel.images.link.edit.tooltip": "Editar el enlace de esta imagen",
  "tinymce.propertypanel.images.link.remove": "Desvincular",
  "tinymce.propertypanel.images.link.remove.tooltip": "Eliminar el enlace de esta imagen",
  "tinymce.propertypanel.images.medium": "Mediano",
  "tinymce.propertypanel.images.medium.tooltip": "Cambiar el tamaño de la imagen a mediano y vincularla a la original",
  "tinymce.propertypanel.images.original": "Original",
  "tinymce.propertypanel.images.original.tooltip": "Restablecer tamaño de imagen al tamaño original",
  "tinymce.propertypanel.images.sizing.tooltip": "Cambiar el tamaño de una imagen a un ancho específico",
  "tinymce.propertypanel.images.small": "Pequeño",
  "tinymce.propertypanel.images.small.tooltip": "Cambiar el tamaño de la imagen a pequeño y vincularla a la original",
  "tinymce.propertypanel.links.edit": "Editar",
  "tinymce.propertypanel.links.edit.tooltip": "Editar enlace en un diálogo",
  "tinymce.propertypanel.links.goto": "Ir al enlace",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Este enlace conduce a contenido de la página que está editando",
  "tinymce.propertypanel.links.unlink": "Desvincular",
  "tinymce.propertypanel.links.unlink.tooltip": "Reemplazar enlace con el texto que contiene",
  "tinymce.searchreplace.replace_desc": "Buscar y reemplazar",
  "tinymce.searchreplace.search_desc": "Buscar",
  "tinymce.searchreplace_dlg.allreplaced.plural": "se hicieron {0} reemplazos",
  "tinymce.searchreplace_dlg.allreplaced.singular": "se hizo 1 reemplazo",
  "tinymce.searchreplace_dlg.close": "Cerrar",
  "tinymce.searchreplace_dlg.direction": "Dirección",
  "tinymce.searchreplace_dlg.down": "Abajo",
  "tinymce.searchreplace_dlg.findlabel": "Buscar",
  "tinymce.searchreplace_dlg.findnext": "Siguiente",
  "tinymce.searchreplace_dlg.findprevious": "Anterior",
  "tinymce.searchreplace_dlg.findwhat": "Qué buscar",
  "tinymce.searchreplace_dlg.mcase": "Coincidir mayúsculas y minúsculas",
  "tinymce.searchreplace_dlg.notfound": "No se hicieron reemplazos",
  "tinymce.searchreplace_dlg.replace": "Reemplazar",
  "tinymce.searchreplace_dlg.replace_title": "Buscar y reemplazar",
  "tinymce.searchreplace_dlg.replaceall": "Reemplazar todas",
  "tinymce.searchreplace_dlg.replacelabel": "Reemplazar",
  "tinymce.searchreplace_dlg.search_title": "Buscar",
  "tinymce.searchreplace_dlg.searchnext_desc": "Buscar de nuevo",
  "tinymce.searchreplace_dlg.up": "Arriba",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "Mostrar/ocultar marcadores de final de línea",
  "tinymce.table": "Tabla",
  "tinymce.table.cell": "Celda",
  "tinymce.table.col": "Columna",
  "tinymce.table.col_after_desc": "Insertar columna a la derecha",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Opción+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Mayús+→",
  "tinymce.table.col_before_desc": "Insertar columna a la izquierda",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Opción+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Mayús+←",
  "tinymce.table.col_copy_desc": "Copiar columna de tabla",
  "tinymce.table.col_cut_desc": "Cortar columna de tabla",
  "tinymce.table.col_highlight": "Columna de encabezamiento",
  "tinymce.table.col_paste_desc": "Pegar columna de tabla",
  "tinymce.table.copy_row_desc": "Copiar fila de tabla",
  "tinymce.table.copy_row_shortcut": "Ctrl+Mayús+C",
  "tinymce.table.cut_row_desc": "Cortar fila de tabla",
  "tinymce.table.cut_row_shortcut": "Ctrl+Mayús+X",
  "tinymce.table.del": "Eliminar tabla",
  "tinymce.table.delete_col_desc": "Eliminar columna",
  "tinymce.table.delete_row_desc": "Eliminar fila",
  "tinymce.table.desc": "Insertar tabla",
  "tinymce.table.fixed_width": "Anchura fija",
  "tinymce.table.fixed_width_tooltip": "Arrastre los bordes de la columna para establecer la anchura. La tabla aparecerá siempre con la anchura que establezca.",
  "tinymce.table.highlight_colour": "Color de resaltado",
  "tinymce.table.merge_cells_desc": "Combinar celdas de tabla",
  "tinymce.table.more.heading": "Configuración de tabla",
  "tinymce.table.numbering_column_desc": "Insertar columna de numeración",
  "tinymce.table.paste_row_after_desc": "Pegar fila debajo",
  "tinymce.table.paste_row_before_desc": "Pegar fila de tabla",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Mayús+V",
  "tinymce.table.responsive": "Responsivo",
  "tinymce.table.responsive_tooltip": "Las columnas de la tabla se ensanchan a medida que agrega contenido. Arrastre los bordes de la columna para establecer el ancho respecto a la otra y a la página.",
  "tinymce.table.row": "Fila",
  "tinymce.table.row_after_desc": "Insertar fila debajo",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Opción+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Mayús+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "Insertar fila arriba",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Opción+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Mayús+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "Fila de encabezamiento",
  "tinymce.table.selection_highlight": "Cambiar color de celda",
  "tinymce.table.split_cells_desc": "Dividir celdas de tabla combinadas",
  "tinymce.table_dlg.cols": "Columnas",
  "tinymce.table_dlg.equal.width.columns": "Columnas con igual ancho",
  "tinymce.table_dlg.fullwidth": "Ancho completo",
  "tinymce.table_dlg.heading": "Primera fila es el título",
  "tinymce.table_dlg.invalid_table_field": "Las filas y columnas deben ser números mayores que cero.",
  "tinymce.table_dlg.rows": "Filas",
  "tinymce.table_dlg.sizetofit": "Ajustar tamaño al contenido",
  "tinymce.table_dlg.title": "Insertar tabla",
  "tinymce.table_dlg.width": "Ancho",
  "tinymce.table_shortcut": "Ctrl+Mayús+I",
  "tinymce.tablepicker.insert_table": "Tabla",
  "tinymce.tablepicker.insert_table_title": "Insertar tabla",
  "tinymce.tablepicker.nested_table_unsupported": "No es posible utilizar tablas anidadas",
  "tinymce.tablepicker.pickerbox.tooltip": "Mantenga presionada la tecla Mayús para hacer una tabla sin título.",
  "tinymce.templates.actions.defined": "Elementos para insertar en esta página.",
  "tinymce.templates.insert-template": "Plantilla",
  "tinymce.templates.insert-template.tooltip": "Insertar plantillas en esta página.",
  "tinymce.templates.placeholder": "Texto instructivo",
  "tinymce.templates.placeholder.add": "Marcador de posición",
  "tinymce.templates.placeholder.add.tooltip": "Insertar un marcador de posición de texto en la página.",
  "tinymce.templates.placeholder.tooltip": "Desaparece cuando un usuario escribe, no se muestra al ver una página.",
  "tinymce.templates.variables.add": "Nueva variable",
  "tinymce.templates.variables.add.tooltip": "Añadir un nuevo campo en la página para que el usuario de la plantilla lo rellene.",
  "tinymce.templates.variables.defined": "Variables para insertar en esta página.",
  "tinymce.templates.variables.insert.tooltip": "Inserta el campo '{'0'}' en la página para que el usuario de la plantilla lo rellene.",
  "tinymce.templates.variables.manage": "Administrar variables",
  "tinymce.templates.variables.none": "No se definieron variables",
  "tinymce.templates.variables.none.tooltip": "No se han creado variables.",
  "tinymce.tools.toolbar_item_hide": "Ocultar herramientas",
  "tinymce.tools.toolbar_item_hide_title": "Ocultar las barras de herramientas",
  "tinymce.tools.toolbar_item_show": "Mostrar herramientas",
  "tinymce.tools.toolbar_item_show_title": "Mostrar las barras de herramientas",
  "tinymce.web.css.resource.name": "Recursos web CSS del editor de Confluence",
  "tinymce.web.js.resource.name": "Recursos web Javascript del editor de Confluence",
  "tinymce.web.resource.name": "Recursos web del editor de Confluence",
  "title.add.blogpost": "Añadir Noticia",
  "title.add.page": "Añadir Página",
  "title.add.page.template": "Crear plantilla",
  "title.comment": "Comentario",
  "title.dashboard": "Cuadro de Mando",
  "title.edit.page.template": "Editar plantilla",
  "title.manage.groups": "Grupos",
  "title.name": "Título",
  "type.allcontent": "Todo el Contenido",
  "unknown.file": "Fichero",
  "unsaved.comment.lost": "Su comentario se perderá.",
  "unsaved.content.lost": "Es posible que los cambios que hiciste no se guarden.",
  "unsaved.template.lost": "Perderá los cambios en la plantilla que no haya guardado.",
  "untitled.draft.title": "Sin título",
  "upm.marketplace.section": "Mercado de Atlassian",
  "usermanagement.label": "Gestión de usuarios",
  "usermanagement.parent.label": "Administración del sitio web",
  "users.name": "Usuarios",
  "view-changes-dialog.close.dialog": "Cerrar",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Cambios no publicados",
  "view.change": "ver cambio",
  "view.profile": "Ver perfil",
  "viewdrafts.page.desc": "Cuando edita una página pero no publica los cambios, se crea un borrador. Seleccione <b>Reanudar</b> para seguir editando o publicar los cambios.",
  "welcome.message.edit": "Comparta aquí enlaces, anuncios e información útiles",
  "welcome.message.edit.link": "Personalizar",
  "word.file": "Documento de Microsoft Word",
  "word.template.file": "Plantilla de Microsoft Word",
  "word97.file": "Documento de Microsoft Word 97",
  "word97.template.file": "Plantilla de Microsoft Word 97",
  "xml.file": "Archivo XML",
  "yes.name": "Si",
  "your.profile.and.settings": "Su perfil y configuraciones",
  "zip.file": "Archivo ZIP"
}